/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CollectRouteImport } from './routes/_collect'
import { Route as MenuRouteImport } from './routes/_menu'
import { Route as CollectScanRouteImport } from './routes/_collect/_scan'
import { Route as MenuIndexRouteImport } from './routes/_menu/index'
import { Route as MenuAdminRouteImport } from './routes/_menu/admin'
import { Route as MenuAuthRouteImport } from './routes/_menu/auth'
import { Route as MenuGameUtilsRouteImport } from './routes/_menu/game-utils'
import { Route as MenuHomeRouteImport } from './routes/_menu/home'
import { Route as MenuLegalRouteImport } from './routes/_menu/legal'
import { Route as MenuPrivacyRouteImport } from './routes/_menu/privacy'
import { Route as MenuWhatsNewRouteImport } from './routes/_menu/whats-new'
import { Route as MenuAdminIndexRouteImport } from './routes/_menu/admin/index'
import { Route as MenuAdminLogRouteImport } from './routes/_menu/admin/log'
import { Route as MenuAdminStatisticsRouteImport } from './routes/_menu/admin/statistics'
import { Route as MenuAdminSyncsRouteImport } from './routes/_menu/admin/syncs'
import { Route as MenuAuthLoginRouteImport } from './routes/_menu/auth/login'
import { Route as MenuAuthRegisterRouteImport } from './routes/_menu/auth/register'
import { Route as MenuAuthSignupRouteImport } from './routes/_menu/auth/signup'
import { Route as MenuAuthUsernameRouteImport } from './routes/_menu/auth/username'
import { Route as MenuCollectionsIndexRouteImport } from './routes/_menu/collections/index'
import { Route as MenuDecksIndexRouteImport } from './routes/_menu/decks/index'
import { Route as MenuGameUtilsIndexRouteImport } from './routes/_menu/game-utils/index'
import { Route as MenuGameUtilsLifeTrackerRouteImport } from './routes/_menu/game-utils/life-tracker'
import { Route as MenuGameUtilsMpcFillRouteImport } from './routes/_menu/game-utils/mpc-fill'
import { Route as MenuGameUtilsProxyPrinterRouteImport } from './routes/_menu/game-utils/proxy-printer'
import { Route as MenuProfileProfileRouteImport } from './routes/_menu/profile/_profile'
import { Route as MenuScanIndexRouteImport } from './routes/_menu/scan/index'
import { Route as MenuScanBenchRouteImport } from './routes/_menu/scan/bench'
import { Route as MenuTournamentsOverviewRouteImport } from './routes/_menu/tournaments/_overview'
import { Route as MenuTournamentsCreateRouteImport } from './routes/_menu/tournaments/create'
import { Route as MenuWatchListsIndexRouteImport } from './routes/_menu/watch-lists/index'
import { Route as MenuWatchListsWatchListUuidRouteImport } from './routes/_menu/watch-lists/$watchListUuid'
import { Route as MenuAdminAccountsIndexRouteImport } from './routes/_menu/admin/accounts/index'
import { Route as MenuAdminAccountsAccountUuidRouteImport } from './routes/_menu/admin/accounts/$accountUuid'
import { Route as MenuAdminBugReportsIndexRouteImport } from './routes/_menu/admin/bug-reports/index'
import { Route as MenuAdminBugReportsNumberRouteImport } from './routes/_menu/admin/bug-reports/$number'
import { Route as MenuCollaboratingDeckUuidDeckRouteImport } from './routes/_menu/collaborating/$deckUuid/_deck'
import { Route as MenuCollectionsCollectionUuidCollectionRouteImport } from './routes/_menu/collections/$collectionUuid/_collection'
import { Route as MenuDecksDeckUuidDeckRouteImport } from './routes/_menu/decks/$deckUuid/_deck'
import { Route as MenuGlobalDecksIndexRouteImport } from './routes/_menu/global/decks/index'
import { Route as MenuGlobalProfilesUsernameRouteImport } from './routes/_menu/global/profiles/$username'
import { Route as MenuProfileProfileIndexRouteImport } from './routes/_menu/profile/_profile/index'
import { Route as MenuProfileProfileSecurityRouteImport } from './routes/_menu/profile/_profile/security'
import { Route as MenuProfileProfileSettingsRouteImport } from './routes/_menu/profile/_profile/settings'
import { Route as MenuScanStagedSessionUuidRouteImport } from './routes/_menu/scan/staged/$sessionUuid'
import { Route as MenuTournamentsTournamentUuidTournamentRouteImport } from './routes/_menu/tournaments/$tournamentUuid/_tournament'
import { Route as MenuTournamentsTournamentUuidEditRouteImport } from './routes/_menu/tournaments/$tournamentUuid/edit'
import { Route as MenuTournamentsOverviewIndexRouteImport } from './routes/_menu/tournaments/_overview/index'
import { Route as MenuTournamentsOverviewMineRouteImport } from './routes/_menu/tournaments/_overview/mine'
import { Route as CollectScanScanLiveIndexRouteImport } from './routes/_collect/_scan/scan/live/index'
import { Route as CollectScanScanLiveSessionUuidRouteImport } from './routes/_collect/_scan/scan/live/$sessionUuid'
import { Route as MenuCollaboratingDeckUuidDeckIndexRouteImport } from './routes/_menu/collaborating/$deckUuid/_deck/index'
import { Route as MenuCollaboratingDeckUuidDeckCardsRouteImport } from './routes/_menu/collaborating/$deckUuid/_deck/cards'
import { Route as MenuCollaboratingDeckUuidDeckStatisticsRouteImport } from './routes/_menu/collaborating/$deckUuid/_deck/statistics'
import { Route as MenuCollectionsCollectionUuidCollectionIndexRouteImport } from './routes/_menu/collections/$collectionUuid/_collection/index'
import { Route as MenuCollectionsCollectionUuidCollectionCardsRouteImport } from './routes/_menu/collections/$collectionUuid/_collection/cards'
import { Route as MenuCollectionsCollectionUuidCollectionOnLoanRouteImport } from './routes/_menu/collections/$collectionUuid/_collection/on-loan'
import { Route as MenuCollectionsCollectionUuidCollectionStatisticsRouteImport } from './routes/_menu/collections/$collectionUuid/_collection/statistics'
import { Route as MenuDecksDeckUuidDeckIndexRouteImport } from './routes/_menu/decks/$deckUuid/_deck/index'
import { Route as MenuDecksDeckUuidDeckAdvisorRouteImport } from './routes/_menu/decks/$deckUuid/_deck/advisor'
import { Route as MenuDecksDeckUuidDeckCardsRouteImport } from './routes/_menu/decks/$deckUuid/_deck/cards'
import { Route as MenuDecksDeckUuidDeckGoldfishRouteImport } from './routes/_menu/decks/$deckUuid/_deck/goldfish'
import { Route as MenuDecksDeckUuidDeckSourcingRouteImport } from './routes/_menu/decks/$deckUuid/_deck/sourcing'
import { Route as MenuDecksDeckUuidDeckStatisticsRouteImport } from './routes/_menu/decks/$deckUuid/_deck/statistics'
import { Route as MenuGlobalCollectionsCollectionUuidCollectionRouteImport } from './routes/_menu/global/collections/$collectionUuid/_collection'
import { Route as MenuGlobalDecksDeckUuidDeckRouteImport } from './routes/_menu/global/decks/$deckUuid/_deck'
import { Route as MenuSharedCollectionsTokenSharedRouteImport } from './routes/_menu/shared/collections/$token/_shared'
import { Route as MenuSharedDecksTokenSharedRouteImport } from './routes/_menu/shared/decks/$token/_shared'
import { Route as MenuSharedTournamentsTokenSharedRouteImport } from './routes/_menu/shared/tournaments/$token/_shared'
import { Route as MenuTournamentsTournamentUuidTournamentIndexRouteImport } from './routes/_menu/tournaments/$tournamentUuid/_tournament/index'
import { Route as MenuTournamentsTournamentUuidTournamentOrganizersRouteImport } from './routes/_menu/tournaments/$tournamentUuid/_tournament/organizers'
import { Route as MenuTournamentsTournamentUuidTournamentParticipantsRouteImport } from './routes/_menu/tournaments/$tournamentUuid/_tournament/participants'
import { Route as MenuTournamentsTournamentUuidTournamentRoundsRouteImport } from './routes/_menu/tournaments/$tournamentUuid/_tournament/rounds'
import { Route as MenuTournamentsTournamentUuidTournamentStandingsRouteImport } from './routes/_menu/tournaments/$tournamentUuid/_tournament/standings'
import { Route as MenuTournamentsTournamentUuidTournamentTopCutRouteImport } from './routes/_menu/tournaments/$tournamentUuid/_tournament/top-cut'
import { Route as MenuDecksDeckUuidDeckHistoryIndexRouteImport } from './routes/_menu/decks/$deckUuid/_deck/history/index'
import { Route as MenuDecksDeckUuidDeckHistoryChangeUuidRouteImport } from './routes/_menu/decks/$deckUuid/_deck/history/$changeUuid'
import { Route as MenuGlobalCollectionsCollectionUuidCollectionIndexRouteImport } from './routes/_menu/global/collections/$collectionUuid/_collection/index'
import { Route as MenuGlobalCollectionsCollectionUuidCollectionCardsRouteImport } from './routes/_menu/global/collections/$collectionUuid/_collection/cards'
import { Route as MenuGlobalCollectionsCollectionUuidCollectionStatisticsRouteImport } from './routes/_menu/global/collections/$collectionUuid/_collection/statistics'
import { Route as MenuGlobalDecksDeckUuidDeckIndexRouteImport } from './routes/_menu/global/decks/$deckUuid/_deck/index'
import { Route as MenuGlobalDecksDeckUuidDeckCardsRouteImport } from './routes/_menu/global/decks/$deckUuid/_deck/cards'
import { Route as MenuGlobalDecksDeckUuidDeckStatisticsRouteImport } from './routes/_menu/global/decks/$deckUuid/_deck/statistics'
import { Route as MenuSharedCollectionsTokenSharedIndexRouteImport } from './routes/_menu/shared/collections/$token/_shared/index'
import { Route as MenuSharedCollectionsTokenSharedCardsRouteImport } from './routes/_menu/shared/collections/$token/_shared/cards'
import { Route as MenuSharedCollectionsTokenSharedStatisticsRouteImport } from './routes/_menu/shared/collections/$token/_shared/statistics'
import { Route as MenuSharedDecksTokenSharedIndexRouteImport } from './routes/_menu/shared/decks/$token/_shared/index'
import { Route as MenuSharedDecksTokenSharedCardsRouteImport } from './routes/_menu/shared/decks/$token/_shared/cards'
import { Route as MenuSharedDecksTokenSharedStatisticsRouteImport } from './routes/_menu/shared/decks/$token/_shared/statistics'
import { Route as MenuSharedTournamentsTokenSharedIndexRouteImport } from './routes/_menu/shared/tournaments/$token/_shared/index'
import { Route as MenuSharedTournamentsTokenSharedParticipantsRouteImport } from './routes/_menu/shared/tournaments/$token/_shared/participants'
import { Route as MenuSharedTournamentsTokenSharedRoundsRouteImport } from './routes/_menu/shared/tournaments/$token/_shared/rounds'
import { Route as MenuSharedTournamentsTokenSharedStandingsRouteImport } from './routes/_menu/shared/tournaments/$token/_shared/standings'
import { Route as MenuSharedTournamentsTokenSharedTopCutRouteImport } from './routes/_menu/shared/tournaments/$token/_shared/top-cut'
import { Route as MenuTournamentsTournamentUuidMatchesMatchUuidLifeRouteImport } from './routes/_menu/tournaments/$tournamentUuid/matches/$matchUuid/life'

const CollectRoute = CollectRouteImport.update({
  id: '/_collect',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuRoute = MenuRouteImport.update({
  id: '/_menu',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectScanRoute = CollectScanRouteImport.update({
  id: '/_scan',
  getParentRoute: () => CollectRoute,
} as any)
const MenuIndexRoute = MenuIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuAdminRoute = MenuAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => MenuRoute,
} as any)
const MenuAuthRoute = MenuAuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => MenuRoute,
} as any)
const MenuGameUtilsRoute = MenuGameUtilsRouteImport.update({
  id: '/game-utils',
  path: '/game-utils',
  getParentRoute: () => MenuRoute,
} as any)
const MenuHomeRoute = MenuHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => MenuRoute,
} as any)
const MenuLegalRoute = MenuLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => MenuRoute,
} as any)
const MenuPrivacyRoute = MenuPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => MenuRoute,
} as any)
const MenuWhatsNewRoute = MenuWhatsNewRouteImport.update({
  id: '/whats-new',
  path: '/whats-new',
  getParentRoute: () => MenuRoute,
} as any)
const MenuAdminIndexRoute = MenuAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuAdminRoute,
} as any)
const MenuAdminLogRoute = MenuAdminLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => MenuAdminRoute,
} as any)
const MenuAdminStatisticsRoute = MenuAdminStatisticsRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => MenuAdminRoute,
} as any)
const MenuAdminSyncsRoute = MenuAdminSyncsRouteImport.update({
  id: '/syncs',
  path: '/syncs',
  getParentRoute: () => MenuAdminRoute,
} as any)
const MenuAuthLoginRoute = MenuAuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => MenuAuthRoute,
} as any)
const MenuAuthRegisterRoute = MenuAuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => MenuAuthRoute,
} as any)
const MenuAuthSignupRoute = MenuAuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => MenuAuthRoute,
} as any)
const MenuAuthUsernameRoute = MenuAuthUsernameRouteImport.update({
  id: '/username',
  path: '/username',
  getParentRoute: () => MenuAuthRoute,
} as any)
const MenuCollectionsIndexRoute = MenuCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuDecksIndexRoute = MenuDecksIndexRouteImport.update({
  id: '/decks/',
  path: '/decks/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuGameUtilsIndexRoute = MenuGameUtilsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuGameUtilsRoute,
} as any)
const MenuGameUtilsLifeTrackerRoute =
  MenuGameUtilsLifeTrackerRouteImport.update({
    id: '/life-tracker',
    path: '/life-tracker',
    getParentRoute: () => MenuGameUtilsRoute,
  } as any)
const MenuGameUtilsMpcFillRoute = MenuGameUtilsMpcFillRouteImport.update({
  id: '/mpc-fill',
  path: '/mpc-fill',
  getParentRoute: () => MenuGameUtilsRoute,
} as any)
const MenuGameUtilsProxyPrinterRoute =
  MenuGameUtilsProxyPrinterRouteImport.update({
    id: '/proxy-printer',
    path: '/proxy-printer',
    getParentRoute: () => MenuGameUtilsRoute,
  } as any)
const MenuProfileProfileRoute = MenuProfileProfileRouteImport.update({
  id: '/profile/_profile',
  path: '/profile',
  getParentRoute: () => MenuRoute,
} as any)
const MenuScanIndexRoute = MenuScanIndexRouteImport.update({
  id: '/scan/',
  path: '/scan/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuScanBenchRoute = MenuScanBenchRouteImport.update({
  id: '/scan/bench',
  path: '/scan/bench',
  getParentRoute: () => MenuRoute,
} as any)
const MenuTournamentsOverviewRoute = MenuTournamentsOverviewRouteImport.update({
  id: '/tournaments/_overview',
  path: '/tournaments',
  getParentRoute: () => MenuRoute,
} as any)
const MenuTournamentsCreateRoute = MenuTournamentsCreateRouteImport.update({
  id: '/tournaments/create',
  path: '/tournaments/create',
  getParentRoute: () => MenuRoute,
} as any)
const MenuWatchListsIndexRoute = MenuWatchListsIndexRouteImport.update({
  id: '/watch-lists/',
  path: '/watch-lists/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuWatchListsWatchListUuidRoute =
  MenuWatchListsWatchListUuidRouteImport.update({
    id: '/watch-lists/$watchListUuid',
    path: '/watch-lists/$watchListUuid',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuAdminAccountsIndexRoute = MenuAdminAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => MenuAdminRoute,
} as any)
const MenuAdminAccountsAccountUuidRoute =
  MenuAdminAccountsAccountUuidRouteImport.update({
    id: '/accounts/$accountUuid',
    path: '/accounts/$accountUuid',
    getParentRoute: () => MenuAdminRoute,
  } as any)
const MenuAdminBugReportsIndexRoute =
  MenuAdminBugReportsIndexRouteImport.update({
    id: '/bug-reports/',
    path: '/bug-reports/',
    getParentRoute: () => MenuAdminRoute,
  } as any)
const MenuAdminBugReportsNumberRoute =
  MenuAdminBugReportsNumberRouteImport.update({
    id: '/bug-reports/$number',
    path: '/bug-reports/$number',
    getParentRoute: () => MenuAdminRoute,
  } as any)
const MenuCollaboratingDeckUuidDeckRoute =
  MenuCollaboratingDeckUuidDeckRouteImport.update({
    id: '/collaborating/$deckUuid/_deck',
    path: '/collaborating/$deckUuid',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuCollectionsCollectionUuidCollectionRoute =
  MenuCollectionsCollectionUuidCollectionRouteImport.update({
    id: '/collections/$collectionUuid/_collection',
    path: '/collections/$collectionUuid',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuDecksDeckUuidDeckRoute = MenuDecksDeckUuidDeckRouteImport.update({
  id: '/decks/$deckUuid/_deck',
  path: '/decks/$deckUuid',
  getParentRoute: () => MenuRoute,
} as any)
const MenuGlobalDecksIndexRoute = MenuGlobalDecksIndexRouteImport.update({
  id: '/global/decks/',
  path: '/global/decks/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuGlobalProfilesUsernameRoute =
  MenuGlobalProfilesUsernameRouteImport.update({
    id: '/global/profiles/$username',
    path: '/global/profiles/$username',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuProfileProfileIndexRoute = MenuProfileProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuProfileProfileRoute,
} as any)
const MenuProfileProfileSecurityRoute =
  MenuProfileProfileSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => MenuProfileProfileRoute,
  } as any)
const MenuProfileProfileSettingsRoute =
  MenuProfileProfileSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => MenuProfileProfileRoute,
  } as any)
const MenuScanStagedSessionUuidRoute =
  MenuScanStagedSessionUuidRouteImport.update({
    id: '/scan/staged/$sessionUuid',
    path: '/scan/staged/$sessionUuid',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuTournamentsTournamentUuidTournamentRoute =
  MenuTournamentsTournamentUuidTournamentRouteImport.update({
    id: '/tournaments/$tournamentUuid/_tournament',
    path: '/tournaments/$tournamentUuid',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuTournamentsTournamentUuidEditRoute =
  MenuTournamentsTournamentUuidEditRouteImport.update({
    id: '/tournaments/$tournamentUuid/edit',
    path: '/tournaments/$tournamentUuid/edit',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuTournamentsOverviewIndexRoute =
  MenuTournamentsOverviewIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuTournamentsOverviewRoute,
  } as any)
const MenuTournamentsOverviewMineRoute =
  MenuTournamentsOverviewMineRouteImport.update({
    id: '/mine',
    path: '/mine',
    getParentRoute: () => MenuTournamentsOverviewRoute,
  } as any)
const CollectScanScanLiveIndexRoute =
  CollectScanScanLiveIndexRouteImport.update({
    id: '/scan/live/',
    path: '/scan/live/',
    getParentRoute: () => CollectScanRoute,
  } as any)
const CollectScanScanLiveSessionUuidRoute =
  CollectScanScanLiveSessionUuidRouteImport.update({
    id: '/scan/live/$sessionUuid',
    path: '/scan/live/$sessionUuid',
    getParentRoute: () => CollectScanRoute,
  } as any)
const MenuCollaboratingDeckUuidDeckIndexRoute =
  MenuCollaboratingDeckUuidDeckIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuCollaboratingDeckUuidDeckRoute,
  } as any)
const MenuCollaboratingDeckUuidDeckCardsRoute =
  MenuCollaboratingDeckUuidDeckCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => MenuCollaboratingDeckUuidDeckRoute,
  } as any)
const MenuCollaboratingDeckUuidDeckStatisticsRoute =
  MenuCollaboratingDeckUuidDeckStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => MenuCollaboratingDeckUuidDeckRoute,
  } as any)
const MenuCollectionsCollectionUuidCollectionIndexRoute =
  MenuCollectionsCollectionUuidCollectionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuCollectionsCollectionUuidCollectionRoute,
  } as any)
const MenuCollectionsCollectionUuidCollectionCardsRoute =
  MenuCollectionsCollectionUuidCollectionCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => MenuCollectionsCollectionUuidCollectionRoute,
  } as any)
const MenuCollectionsCollectionUuidCollectionOnLoanRoute =
  MenuCollectionsCollectionUuidCollectionOnLoanRouteImport.update({
    id: '/on-loan',
    path: '/on-loan',
    getParentRoute: () => MenuCollectionsCollectionUuidCollectionRoute,
  } as any)
const MenuCollectionsCollectionUuidCollectionStatisticsRoute =
  MenuCollectionsCollectionUuidCollectionStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => MenuCollectionsCollectionUuidCollectionRoute,
  } as any)
const MenuDecksDeckUuidDeckIndexRoute =
  MenuDecksDeckUuidDeckIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuDecksDeckUuidDeckAdvisorRoute =
  MenuDecksDeckUuidDeckAdvisorRouteImport.update({
    id: '/advisor',
    path: '/advisor',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuDecksDeckUuidDeckCardsRoute =
  MenuDecksDeckUuidDeckCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuDecksDeckUuidDeckGoldfishRoute =
  MenuDecksDeckUuidDeckGoldfishRouteImport.update({
    id: '/goldfish',
    path: '/goldfish',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuDecksDeckUuidDeckSourcingRoute =
  MenuDecksDeckUuidDeckSourcingRouteImport.update({
    id: '/sourcing',
    path: '/sourcing',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuDecksDeckUuidDeckStatisticsRoute =
  MenuDecksDeckUuidDeckStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuGlobalCollectionsCollectionUuidCollectionRoute =
  MenuGlobalCollectionsCollectionUuidCollectionRouteImport.update({
    id: '/global/collections/$collectionUuid/_collection',
    path: '/global/collections/$collectionUuid',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuGlobalDecksDeckUuidDeckRoute =
  MenuGlobalDecksDeckUuidDeckRouteImport.update({
    id: '/global/decks/$deckUuid/_deck',
    path: '/global/decks/$deckUuid',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuSharedCollectionsTokenSharedRoute =
  MenuSharedCollectionsTokenSharedRouteImport.update({
    id: '/shared/collections/$token/_shared',
    path: '/shared/collections/$token',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuSharedDecksTokenSharedRoute =
  MenuSharedDecksTokenSharedRouteImport.update({
    id: '/shared/decks/$token/_shared',
    path: '/shared/decks/$token',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuSharedTournamentsTokenSharedRoute =
  MenuSharedTournamentsTokenSharedRouteImport.update({
    id: '/shared/tournaments/$token/_shared',
    path: '/shared/tournaments/$token',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuTournamentsTournamentUuidTournamentIndexRoute =
  MenuTournamentsTournamentUuidTournamentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuTournamentsTournamentUuidTournamentRoute,
  } as any)
const MenuTournamentsTournamentUuidTournamentOrganizersRoute =
  MenuTournamentsTournamentUuidTournamentOrganizersRouteImport.update({
    id: '/organizers',
    path: '/organizers',
    getParentRoute: () => MenuTournamentsTournamentUuidTournamentRoute,
  } as any)
const MenuTournamentsTournamentUuidTournamentParticipantsRoute =
  MenuTournamentsTournamentUuidTournamentParticipantsRouteImport.update({
    id: '/participants',
    path: '/participants',
    getParentRoute: () => MenuTournamentsTournamentUuidTournamentRoute,
  } as any)
const MenuTournamentsTournamentUuidTournamentRoundsRoute =
  MenuTournamentsTournamentUuidTournamentRoundsRouteImport.update({
    id: '/rounds',
    path: '/rounds',
    getParentRoute: () => MenuTournamentsTournamentUuidTournamentRoute,
  } as any)
const MenuTournamentsTournamentUuidTournamentStandingsRoute =
  MenuTournamentsTournamentUuidTournamentStandingsRouteImport.update({
    id: '/standings',
    path: '/standings',
    getParentRoute: () => MenuTournamentsTournamentUuidTournamentRoute,
  } as any)
const MenuTournamentsTournamentUuidTournamentTopCutRoute =
  MenuTournamentsTournamentUuidTournamentTopCutRouteImport.update({
    id: '/top-cut',
    path: '/top-cut',
    getParentRoute: () => MenuTournamentsTournamentUuidTournamentRoute,
  } as any)
const MenuDecksDeckUuidDeckHistoryIndexRoute =
  MenuDecksDeckUuidDeckHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuDecksDeckUuidDeckHistoryChangeUuidRoute =
  MenuDecksDeckUuidDeckHistoryChangeUuidRouteImport.update({
    id: '/history/$changeUuid',
    path: '/history/$changeUuid',
    getParentRoute: () => MenuDecksDeckUuidDeckRoute,
  } as any)
const MenuGlobalCollectionsCollectionUuidCollectionIndexRoute =
  MenuGlobalCollectionsCollectionUuidCollectionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuGlobalCollectionsCollectionUuidCollectionRoute,
  } as any)
const MenuGlobalCollectionsCollectionUuidCollectionCardsRoute =
  MenuGlobalCollectionsCollectionUuidCollectionCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => MenuGlobalCollectionsCollectionUuidCollectionRoute,
  } as any)
const MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute =
  MenuGlobalCollectionsCollectionUuidCollectionStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => MenuGlobalCollectionsCollectionUuidCollectionRoute,
  } as any)
const MenuGlobalDecksDeckUuidDeckIndexRoute =
  MenuGlobalDecksDeckUuidDeckIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuGlobalDecksDeckUuidDeckRoute,
  } as any)
const MenuGlobalDecksDeckUuidDeckCardsRoute =
  MenuGlobalDecksDeckUuidDeckCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => MenuGlobalDecksDeckUuidDeckRoute,
  } as any)
const MenuGlobalDecksDeckUuidDeckStatisticsRoute =
  MenuGlobalDecksDeckUuidDeckStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => MenuGlobalDecksDeckUuidDeckRoute,
  } as any)
const MenuSharedCollectionsTokenSharedIndexRoute =
  MenuSharedCollectionsTokenSharedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuSharedCollectionsTokenSharedRoute,
  } as any)
const MenuSharedCollectionsTokenSharedCardsRoute =
  MenuSharedCollectionsTokenSharedCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => MenuSharedCollectionsTokenSharedRoute,
  } as any)
const MenuSharedCollectionsTokenSharedStatisticsRoute =
  MenuSharedCollectionsTokenSharedStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => MenuSharedCollectionsTokenSharedRoute,
  } as any)
const MenuSharedDecksTokenSharedIndexRoute =
  MenuSharedDecksTokenSharedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuSharedDecksTokenSharedRoute,
  } as any)
const MenuSharedDecksTokenSharedCardsRoute =
  MenuSharedDecksTokenSharedCardsRouteImport.update({
    id: '/cards',
    path: '/cards',
    getParentRoute: () => MenuSharedDecksTokenSharedRoute,
  } as any)
const MenuSharedDecksTokenSharedStatisticsRoute =
  MenuSharedDecksTokenSharedStatisticsRouteImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => MenuSharedDecksTokenSharedRoute,
  } as any)
const MenuSharedTournamentsTokenSharedIndexRoute =
  MenuSharedTournamentsTokenSharedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MenuSharedTournamentsTokenSharedRoute,
  } as any)
const MenuSharedTournamentsTokenSharedParticipantsRoute =
  MenuSharedTournamentsTokenSharedParticipantsRouteImport.update({
    id: '/participants',
    path: '/participants',
    getParentRoute: () => MenuSharedTournamentsTokenSharedRoute,
  } as any)
const MenuSharedTournamentsTokenSharedRoundsRoute =
  MenuSharedTournamentsTokenSharedRoundsRouteImport.update({
    id: '/rounds',
    path: '/rounds',
    getParentRoute: () => MenuSharedTournamentsTokenSharedRoute,
  } as any)
const MenuSharedTournamentsTokenSharedStandingsRoute =
  MenuSharedTournamentsTokenSharedStandingsRouteImport.update({
    id: '/standings',
    path: '/standings',
    getParentRoute: () => MenuSharedTournamentsTokenSharedRoute,
  } as any)
const MenuSharedTournamentsTokenSharedTopCutRoute =
  MenuSharedTournamentsTokenSharedTopCutRouteImport.update({
    id: '/top-cut',
    path: '/top-cut',
    getParentRoute: () => MenuSharedTournamentsTokenSharedRoute,
  } as any)
const MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute =
  MenuTournamentsTournamentUuidMatchesMatchUuidLifeRouteImport.update({
    id: '/tournaments/$tournamentUuid/matches/$matchUuid/life',
    path: '/tournaments/$tournamentUuid/matches/$matchUuid/life',
    getParentRoute: () => MenuRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof MenuIndexRoute
  '/admin': typeof MenuAdminRouteWithChildren
  '/auth': typeof MenuAuthRouteWithChildren
  '/game-utils': typeof MenuGameUtilsRouteWithChildren
  '/home': typeof MenuHomeRoute
  '/legal': typeof MenuLegalRoute
  '/privacy': typeof MenuPrivacyRoute
  '/whats-new': typeof MenuWhatsNewRoute
  '/admin/log': typeof MenuAdminLogRoute
  '/admin/statistics': typeof MenuAdminStatisticsRoute
  '/admin/syncs': typeof MenuAdminSyncsRoute
  '/auth/login': typeof MenuAuthLoginRoute
  '/auth/register': typeof MenuAuthRegisterRoute
  '/auth/signup': typeof MenuAuthSignupRoute
  '/auth/username': typeof MenuAuthUsernameRoute
  '/game-utils/life-tracker': typeof MenuGameUtilsLifeTrackerRoute
  '/game-utils/mpc-fill': typeof MenuGameUtilsMpcFillRoute
  '/game-utils/proxy-printer': typeof MenuGameUtilsProxyPrinterRoute
  '/profile': typeof MenuProfileProfileRouteWithChildren
  '/scan/bench': typeof MenuScanBenchRoute
  '/tournaments': typeof MenuTournamentsOverviewRouteWithChildren
  '/tournaments/create': typeof MenuTournamentsCreateRoute
  '/watch-lists/$watchListUuid': typeof MenuWatchListsWatchListUuidRoute
  '/admin/': typeof MenuAdminIndexRoute
  '/collections/': typeof MenuCollectionsIndexRoute
  '/decks/': typeof MenuDecksIndexRoute
  '/game-utils/': typeof MenuGameUtilsIndexRoute
  '/scan/': typeof MenuScanIndexRoute
  '/watch-lists/': typeof MenuWatchListsIndexRoute
  '/admin/accounts/$accountUuid': typeof MenuAdminAccountsAccountUuidRoute
  '/admin/bug-reports/$number': typeof MenuAdminBugReportsNumberRoute
  '/collaborating/$deckUuid': typeof MenuCollaboratingDeckUuidDeckRouteWithChildren
  '/collections/$collectionUuid': typeof MenuCollectionsCollectionUuidCollectionRouteWithChildren
  '/decks/$deckUuid': typeof MenuDecksDeckUuidDeckRouteWithChildren
  '/global/profiles/$username': typeof MenuGlobalProfilesUsernameRoute
  '/profile/security': typeof MenuProfileProfileSecurityRoute
  '/profile/settings': typeof MenuProfileProfileSettingsRoute
  '/scan/staged/$sessionUuid': typeof MenuScanStagedSessionUuidRoute
  '/tournaments/$tournamentUuid': typeof MenuTournamentsTournamentUuidTournamentRouteWithChildren
  '/tournaments/$tournamentUuid/edit': typeof MenuTournamentsTournamentUuidEditRoute
  '/tournaments/mine': typeof MenuTournamentsOverviewMineRoute
  '/admin/accounts/': typeof MenuAdminAccountsIndexRoute
  '/admin/bug-reports/': typeof MenuAdminBugReportsIndexRoute
  '/global/decks/': typeof MenuGlobalDecksIndexRoute
  '/profile/': typeof MenuProfileProfileIndexRoute
  '/tournaments/': typeof MenuTournamentsOverviewIndexRoute
  '/scan/live/$sessionUuid': typeof CollectScanScanLiveSessionUuidRoute
  '/collaborating/$deckUuid/cards': typeof MenuCollaboratingDeckUuidDeckCardsRoute
  '/collaborating/$deckUuid/statistics': typeof MenuCollaboratingDeckUuidDeckStatisticsRoute
  '/collections/$collectionUuid/cards': typeof MenuCollectionsCollectionUuidCollectionCardsRoute
  '/collections/$collectionUuid/on-loan': typeof MenuCollectionsCollectionUuidCollectionOnLoanRoute
  '/collections/$collectionUuid/statistics': typeof MenuCollectionsCollectionUuidCollectionStatisticsRoute
  '/decks/$deckUuid/advisor': typeof MenuDecksDeckUuidDeckAdvisorRoute
  '/decks/$deckUuid/cards': typeof MenuDecksDeckUuidDeckCardsRoute
  '/decks/$deckUuid/goldfish': typeof MenuDecksDeckUuidDeckGoldfishRoute
  '/decks/$deckUuid/sourcing': typeof MenuDecksDeckUuidDeckSourcingRoute
  '/decks/$deckUuid/statistics': typeof MenuDecksDeckUuidDeckStatisticsRoute
  '/global/collections/$collectionUuid': typeof MenuGlobalCollectionsCollectionUuidCollectionRouteWithChildren
  '/global/decks/$deckUuid': typeof MenuGlobalDecksDeckUuidDeckRouteWithChildren
  '/shared/collections/$token': typeof MenuSharedCollectionsTokenSharedRouteWithChildren
  '/shared/decks/$token': typeof MenuSharedDecksTokenSharedRouteWithChildren
  '/shared/tournaments/$token': typeof MenuSharedTournamentsTokenSharedRouteWithChildren
  '/tournaments/$tournamentUuid/organizers': typeof MenuTournamentsTournamentUuidTournamentOrganizersRoute
  '/tournaments/$tournamentUuid/participants': typeof MenuTournamentsTournamentUuidTournamentParticipantsRoute
  '/tournaments/$tournamentUuid/rounds': typeof MenuTournamentsTournamentUuidTournamentRoundsRoute
  '/tournaments/$tournamentUuid/standings': typeof MenuTournamentsTournamentUuidTournamentStandingsRoute
  '/tournaments/$tournamentUuid/top-cut': typeof MenuTournamentsTournamentUuidTournamentTopCutRoute
  '/scan/live/': typeof CollectScanScanLiveIndexRoute
  '/collaborating/$deckUuid/': typeof MenuCollaboratingDeckUuidDeckIndexRoute
  '/collections/$collectionUuid/': typeof MenuCollectionsCollectionUuidCollectionIndexRoute
  '/decks/$deckUuid/': typeof MenuDecksDeckUuidDeckIndexRoute
  '/tournaments/$tournamentUuid/': typeof MenuTournamentsTournamentUuidTournamentIndexRoute
  '/decks/$deckUuid/history/$changeUuid': typeof MenuDecksDeckUuidDeckHistoryChangeUuidRoute
  '/global/collections/$collectionUuid/cards': typeof MenuGlobalCollectionsCollectionUuidCollectionCardsRoute
  '/global/collections/$collectionUuid/statistics': typeof MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute
  '/global/decks/$deckUuid/cards': typeof MenuGlobalDecksDeckUuidDeckCardsRoute
  '/global/decks/$deckUuid/statistics': typeof MenuGlobalDecksDeckUuidDeckStatisticsRoute
  '/shared/collections/$token/cards': typeof MenuSharedCollectionsTokenSharedCardsRoute
  '/shared/collections/$token/statistics': typeof MenuSharedCollectionsTokenSharedStatisticsRoute
  '/shared/decks/$token/cards': typeof MenuSharedDecksTokenSharedCardsRoute
  '/shared/decks/$token/statistics': typeof MenuSharedDecksTokenSharedStatisticsRoute
  '/shared/tournaments/$token/participants': typeof MenuSharedTournamentsTokenSharedParticipantsRoute
  '/shared/tournaments/$token/rounds': typeof MenuSharedTournamentsTokenSharedRoundsRoute
  '/shared/tournaments/$token/standings': typeof MenuSharedTournamentsTokenSharedStandingsRoute
  '/shared/tournaments/$token/top-cut': typeof MenuSharedTournamentsTokenSharedTopCutRoute
  '/tournaments/$tournamentUuid/matches/$matchUuid/life': typeof MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute
  '/decks/$deckUuid/history/': typeof MenuDecksDeckUuidDeckHistoryIndexRoute
  '/global/collections/$collectionUuid/': typeof MenuGlobalCollectionsCollectionUuidCollectionIndexRoute
  '/global/decks/$deckUuid/': typeof MenuGlobalDecksDeckUuidDeckIndexRoute
  '/shared/collections/$token/': typeof MenuSharedCollectionsTokenSharedIndexRoute
  '/shared/decks/$token/': typeof MenuSharedDecksTokenSharedIndexRoute
  '/shared/tournaments/$token/': typeof MenuSharedTournamentsTokenSharedIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof MenuIndexRoute
  '/auth': typeof MenuAuthRouteWithChildren
  '/home': typeof MenuHomeRoute
  '/legal': typeof MenuLegalRoute
  '/privacy': typeof MenuPrivacyRoute
  '/whats-new': typeof MenuWhatsNewRoute
  '/admin/log': typeof MenuAdminLogRoute
  '/admin/statistics': typeof MenuAdminStatisticsRoute
  '/admin/syncs': typeof MenuAdminSyncsRoute
  '/auth/login': typeof MenuAuthLoginRoute
  '/auth/register': typeof MenuAuthRegisterRoute
  '/auth/signup': typeof MenuAuthSignupRoute
  '/auth/username': typeof MenuAuthUsernameRoute
  '/game-utils/life-tracker': typeof MenuGameUtilsLifeTrackerRoute
  '/game-utils/mpc-fill': typeof MenuGameUtilsMpcFillRoute
  '/game-utils/proxy-printer': typeof MenuGameUtilsProxyPrinterRoute
  '/scan/bench': typeof MenuScanBenchRoute
  '/tournaments/create': typeof MenuTournamentsCreateRoute
  '/watch-lists/$watchListUuid': typeof MenuWatchListsWatchListUuidRoute
  '/admin': typeof MenuAdminIndexRoute
  '/collections': typeof MenuCollectionsIndexRoute
  '/decks': typeof MenuDecksIndexRoute
  '/game-utils': typeof MenuGameUtilsIndexRoute
  '/scan': typeof MenuScanIndexRoute
  '/watch-lists': typeof MenuWatchListsIndexRoute
  '/admin/accounts/$accountUuid': typeof MenuAdminAccountsAccountUuidRoute
  '/admin/bug-reports/$number': typeof MenuAdminBugReportsNumberRoute
  '/global/profiles/$username': typeof MenuGlobalProfilesUsernameRoute
  '/profile/security': typeof MenuProfileProfileSecurityRoute
  '/profile/settings': typeof MenuProfileProfileSettingsRoute
  '/scan/staged/$sessionUuid': typeof MenuScanStagedSessionUuidRoute
  '/tournaments/$tournamentUuid/edit': typeof MenuTournamentsTournamentUuidEditRoute
  '/tournaments/mine': typeof MenuTournamentsOverviewMineRoute
  '/admin/accounts': typeof MenuAdminAccountsIndexRoute
  '/admin/bug-reports': typeof MenuAdminBugReportsIndexRoute
  '/global/decks': typeof MenuGlobalDecksIndexRoute
  '/profile': typeof MenuProfileProfileIndexRoute
  '/tournaments': typeof MenuTournamentsOverviewIndexRoute
  '/scan/live/$sessionUuid': typeof CollectScanScanLiveSessionUuidRoute
  '/collaborating/$deckUuid/cards': typeof MenuCollaboratingDeckUuidDeckCardsRoute
  '/collaborating/$deckUuid/statistics': typeof MenuCollaboratingDeckUuidDeckStatisticsRoute
  '/collections/$collectionUuid/cards': typeof MenuCollectionsCollectionUuidCollectionCardsRoute
  '/collections/$collectionUuid/on-loan': typeof MenuCollectionsCollectionUuidCollectionOnLoanRoute
  '/collections/$collectionUuid/statistics': typeof MenuCollectionsCollectionUuidCollectionStatisticsRoute
  '/decks/$deckUuid/advisor': typeof MenuDecksDeckUuidDeckAdvisorRoute
  '/decks/$deckUuid/cards': typeof MenuDecksDeckUuidDeckCardsRoute
  '/decks/$deckUuid/goldfish': typeof MenuDecksDeckUuidDeckGoldfishRoute
  '/decks/$deckUuid/sourcing': typeof MenuDecksDeckUuidDeckSourcingRoute
  '/decks/$deckUuid/statistics': typeof MenuDecksDeckUuidDeckStatisticsRoute
  '/tournaments/$tournamentUuid/organizers': typeof MenuTournamentsTournamentUuidTournamentOrganizersRoute
  '/tournaments/$tournamentUuid/participants': typeof MenuTournamentsTournamentUuidTournamentParticipantsRoute
  '/tournaments/$tournamentUuid/rounds': typeof MenuTournamentsTournamentUuidTournamentRoundsRoute
  '/tournaments/$tournamentUuid/standings': typeof MenuTournamentsTournamentUuidTournamentStandingsRoute
  '/tournaments/$tournamentUuid/top-cut': typeof MenuTournamentsTournamentUuidTournamentTopCutRoute
  '/scan/live': typeof CollectScanScanLiveIndexRoute
  '/collaborating/$deckUuid': typeof MenuCollaboratingDeckUuidDeckIndexRoute
  '/collections/$collectionUuid': typeof MenuCollectionsCollectionUuidCollectionIndexRoute
  '/decks/$deckUuid': typeof MenuDecksDeckUuidDeckIndexRoute
  '/tournaments/$tournamentUuid': typeof MenuTournamentsTournamentUuidTournamentIndexRoute
  '/decks/$deckUuid/history/$changeUuid': typeof MenuDecksDeckUuidDeckHistoryChangeUuidRoute
  '/global/collections/$collectionUuid/cards': typeof MenuGlobalCollectionsCollectionUuidCollectionCardsRoute
  '/global/collections/$collectionUuid/statistics': typeof MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute
  '/global/decks/$deckUuid/cards': typeof MenuGlobalDecksDeckUuidDeckCardsRoute
  '/global/decks/$deckUuid/statistics': typeof MenuGlobalDecksDeckUuidDeckStatisticsRoute
  '/shared/collections/$token/cards': typeof MenuSharedCollectionsTokenSharedCardsRoute
  '/shared/collections/$token/statistics': typeof MenuSharedCollectionsTokenSharedStatisticsRoute
  '/shared/decks/$token/cards': typeof MenuSharedDecksTokenSharedCardsRoute
  '/shared/decks/$token/statistics': typeof MenuSharedDecksTokenSharedStatisticsRoute
  '/shared/tournaments/$token/participants': typeof MenuSharedTournamentsTokenSharedParticipantsRoute
  '/shared/tournaments/$token/rounds': typeof MenuSharedTournamentsTokenSharedRoundsRoute
  '/shared/tournaments/$token/standings': typeof MenuSharedTournamentsTokenSharedStandingsRoute
  '/shared/tournaments/$token/top-cut': typeof MenuSharedTournamentsTokenSharedTopCutRoute
  '/tournaments/$tournamentUuid/matches/$matchUuid/life': typeof MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute
  '/decks/$deckUuid/history': typeof MenuDecksDeckUuidDeckHistoryIndexRoute
  '/global/collections/$collectionUuid': typeof MenuGlobalCollectionsCollectionUuidCollectionIndexRoute
  '/global/decks/$deckUuid': typeof MenuGlobalDecksDeckUuidDeckIndexRoute
  '/shared/collections/$token': typeof MenuSharedCollectionsTokenSharedIndexRoute
  '/shared/decks/$token': typeof MenuSharedDecksTokenSharedIndexRoute
  '/shared/tournaments/$token': typeof MenuSharedTournamentsTokenSharedIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_collect': typeof CollectRouteWithChildren
  '/_menu': typeof MenuRouteWithChildren
  '/_collect/_scan': typeof CollectScanRouteWithChildren
  '/_menu/admin': typeof MenuAdminRouteWithChildren
  '/_menu/auth': typeof MenuAuthRouteWithChildren
  '/_menu/game-utils': typeof MenuGameUtilsRouteWithChildren
  '/_menu/home': typeof MenuHomeRoute
  '/_menu/legal': typeof MenuLegalRoute
  '/_menu/privacy': typeof MenuPrivacyRoute
  '/_menu/whats-new': typeof MenuWhatsNewRoute
  '/_menu/': typeof MenuIndexRoute
  '/_menu/admin/log': typeof MenuAdminLogRoute
  '/_menu/admin/statistics': typeof MenuAdminStatisticsRoute
  '/_menu/admin/syncs': typeof MenuAdminSyncsRoute
  '/_menu/auth/login': typeof MenuAuthLoginRoute
  '/_menu/auth/register': typeof MenuAuthRegisterRoute
  '/_menu/auth/signup': typeof MenuAuthSignupRoute
  '/_menu/auth/username': typeof MenuAuthUsernameRoute
  '/_menu/game-utils/life-tracker': typeof MenuGameUtilsLifeTrackerRoute
  '/_menu/game-utils/mpc-fill': typeof MenuGameUtilsMpcFillRoute
  '/_menu/game-utils/proxy-printer': typeof MenuGameUtilsProxyPrinterRoute
  '/_menu/profile/_profile': typeof MenuProfileProfileRouteWithChildren
  '/_menu/scan/bench': typeof MenuScanBenchRoute
  '/_menu/tournaments/_overview': typeof MenuTournamentsOverviewRouteWithChildren
  '/_menu/tournaments/create': typeof MenuTournamentsCreateRoute
  '/_menu/watch-lists/$watchListUuid': typeof MenuWatchListsWatchListUuidRoute
  '/_menu/admin/': typeof MenuAdminIndexRoute
  '/_menu/collections/': typeof MenuCollectionsIndexRoute
  '/_menu/decks/': typeof MenuDecksIndexRoute
  '/_menu/game-utils/': typeof MenuGameUtilsIndexRoute
  '/_menu/scan/': typeof MenuScanIndexRoute
  '/_menu/watch-lists/': typeof MenuWatchListsIndexRoute
  '/_menu/admin/accounts/$accountUuid': typeof MenuAdminAccountsAccountUuidRoute
  '/_menu/admin/bug-reports/$number': typeof MenuAdminBugReportsNumberRoute
  '/_menu/collaborating/$deckUuid/_deck': typeof MenuCollaboratingDeckUuidDeckRouteWithChildren
  '/_menu/collections/$collectionUuid/_collection': typeof MenuCollectionsCollectionUuidCollectionRouteWithChildren
  '/_menu/decks/$deckUuid/_deck': typeof MenuDecksDeckUuidDeckRouteWithChildren
  '/_menu/global/profiles/$username': typeof MenuGlobalProfilesUsernameRoute
  '/_menu/profile/_profile/security': typeof MenuProfileProfileSecurityRoute
  '/_menu/profile/_profile/settings': typeof MenuProfileProfileSettingsRoute
  '/_menu/scan/staged/$sessionUuid': typeof MenuScanStagedSessionUuidRoute
  '/_menu/tournaments/$tournamentUuid/_tournament': typeof MenuTournamentsTournamentUuidTournamentRouteWithChildren
  '/_menu/tournaments/$tournamentUuid/edit': typeof MenuTournamentsTournamentUuidEditRoute
  '/_menu/tournaments/_overview/mine': typeof MenuTournamentsOverviewMineRoute
  '/_menu/admin/accounts/': typeof MenuAdminAccountsIndexRoute
  '/_menu/admin/bug-reports/': typeof MenuAdminBugReportsIndexRoute
  '/_menu/global/decks/': typeof MenuGlobalDecksIndexRoute
  '/_menu/profile/_profile/': typeof MenuProfileProfileIndexRoute
  '/_menu/tournaments/_overview/': typeof MenuTournamentsOverviewIndexRoute
  '/_collect/_scan/scan/live/$sessionUuid': typeof CollectScanScanLiveSessionUuidRoute
  '/_menu/collaborating/$deckUuid/_deck/cards': typeof MenuCollaboratingDeckUuidDeckCardsRoute
  '/_menu/collaborating/$deckUuid/_deck/statistics': typeof MenuCollaboratingDeckUuidDeckStatisticsRoute
  '/_menu/collections/$collectionUuid/_collection/cards': typeof MenuCollectionsCollectionUuidCollectionCardsRoute
  '/_menu/collections/$collectionUuid/_collection/on-loan': typeof MenuCollectionsCollectionUuidCollectionOnLoanRoute
  '/_menu/collections/$collectionUuid/_collection/statistics': typeof MenuCollectionsCollectionUuidCollectionStatisticsRoute
  '/_menu/decks/$deckUuid/_deck/advisor': typeof MenuDecksDeckUuidDeckAdvisorRoute
  '/_menu/decks/$deckUuid/_deck/cards': typeof MenuDecksDeckUuidDeckCardsRoute
  '/_menu/decks/$deckUuid/_deck/goldfish': typeof MenuDecksDeckUuidDeckGoldfishRoute
  '/_menu/decks/$deckUuid/_deck/sourcing': typeof MenuDecksDeckUuidDeckSourcingRoute
  '/_menu/decks/$deckUuid/_deck/statistics': typeof MenuDecksDeckUuidDeckStatisticsRoute
  '/_menu/global/collections/$collectionUuid/_collection': typeof MenuGlobalCollectionsCollectionUuidCollectionRouteWithChildren
  '/_menu/global/decks/$deckUuid/_deck': typeof MenuGlobalDecksDeckUuidDeckRouteWithChildren
  '/_menu/shared/collections/$token/_shared': typeof MenuSharedCollectionsTokenSharedRouteWithChildren
  '/_menu/shared/decks/$token/_shared': typeof MenuSharedDecksTokenSharedRouteWithChildren
  '/_menu/shared/tournaments/$token/_shared': typeof MenuSharedTournamentsTokenSharedRouteWithChildren
  '/_menu/tournaments/$tournamentUuid/_tournament/organizers': typeof MenuTournamentsTournamentUuidTournamentOrganizersRoute
  '/_menu/tournaments/$tournamentUuid/_tournament/participants': typeof MenuTournamentsTournamentUuidTournamentParticipantsRoute
  '/_menu/tournaments/$tournamentUuid/_tournament/rounds': typeof MenuTournamentsTournamentUuidTournamentRoundsRoute
  '/_menu/tournaments/$tournamentUuid/_tournament/standings': typeof MenuTournamentsTournamentUuidTournamentStandingsRoute
  '/_menu/tournaments/$tournamentUuid/_tournament/top-cut': typeof MenuTournamentsTournamentUuidTournamentTopCutRoute
  '/_collect/_scan/scan/live/': typeof CollectScanScanLiveIndexRoute
  '/_menu/collaborating/$deckUuid/_deck/': typeof MenuCollaboratingDeckUuidDeckIndexRoute
  '/_menu/collections/$collectionUuid/_collection/': typeof MenuCollectionsCollectionUuidCollectionIndexRoute
  '/_menu/decks/$deckUuid/_deck/': typeof MenuDecksDeckUuidDeckIndexRoute
  '/_menu/tournaments/$tournamentUuid/_tournament/': typeof MenuTournamentsTournamentUuidTournamentIndexRoute
  '/_menu/decks/$deckUuid/_deck/history/$changeUuid': typeof MenuDecksDeckUuidDeckHistoryChangeUuidRoute
  '/_menu/global/collections/$collectionUuid/_collection/cards': typeof MenuGlobalCollectionsCollectionUuidCollectionCardsRoute
  '/_menu/global/collections/$collectionUuid/_collection/statistics': typeof MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute
  '/_menu/global/decks/$deckUuid/_deck/cards': typeof MenuGlobalDecksDeckUuidDeckCardsRoute
  '/_menu/global/decks/$deckUuid/_deck/statistics': typeof MenuGlobalDecksDeckUuidDeckStatisticsRoute
  '/_menu/shared/collections/$token/_shared/cards': typeof MenuSharedCollectionsTokenSharedCardsRoute
  '/_menu/shared/collections/$token/_shared/statistics': typeof MenuSharedCollectionsTokenSharedStatisticsRoute
  '/_menu/shared/decks/$token/_shared/cards': typeof MenuSharedDecksTokenSharedCardsRoute
  '/_menu/shared/decks/$token/_shared/statistics': typeof MenuSharedDecksTokenSharedStatisticsRoute
  '/_menu/shared/tournaments/$token/_shared/participants': typeof MenuSharedTournamentsTokenSharedParticipantsRoute
  '/_menu/shared/tournaments/$token/_shared/rounds': typeof MenuSharedTournamentsTokenSharedRoundsRoute
  '/_menu/shared/tournaments/$token/_shared/standings': typeof MenuSharedTournamentsTokenSharedStandingsRoute
  '/_menu/shared/tournaments/$token/_shared/top-cut': typeof MenuSharedTournamentsTokenSharedTopCutRoute
  '/_menu/tournaments/$tournamentUuid/matches/$matchUuid/life': typeof MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute
  '/_menu/decks/$deckUuid/_deck/history/': typeof MenuDecksDeckUuidDeckHistoryIndexRoute
  '/_menu/global/collections/$collectionUuid/_collection/': typeof MenuGlobalCollectionsCollectionUuidCollectionIndexRoute
  '/_menu/global/decks/$deckUuid/_deck/': typeof MenuGlobalDecksDeckUuidDeckIndexRoute
  '/_menu/shared/collections/$token/_shared/': typeof MenuSharedCollectionsTokenSharedIndexRoute
  '/_menu/shared/decks/$token/_shared/': typeof MenuSharedDecksTokenSharedIndexRoute
  '/_menu/shared/tournaments/$token/_shared/': typeof MenuSharedTournamentsTokenSharedIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/auth'
    | '/game-utils'
    | '/home'
    | '/legal'
    | '/privacy'
    | '/whats-new'
    | '/admin/log'
    | '/admin/statistics'
    | '/admin/syncs'
    | '/auth/login'
    | '/auth/register'
    | '/auth/signup'
    | '/auth/username'
    | '/game-utils/life-tracker'
    | '/game-utils/mpc-fill'
    | '/game-utils/proxy-printer'
    | '/profile'
    | '/scan/bench'
    | '/tournaments'
    | '/tournaments/create'
    | '/watch-lists/$watchListUuid'
    | '/admin/'
    | '/collections/'
    | '/decks/'
    | '/game-utils/'
    | '/scan/'
    | '/watch-lists/'
    | '/admin/accounts/$accountUuid'
    | '/admin/bug-reports/$number'
    | '/collaborating/$deckUuid'
    | '/collections/$collectionUuid'
    | '/decks/$deckUuid'
    | '/global/profiles/$username'
    | '/profile/security'
    | '/profile/settings'
    | '/scan/staged/$sessionUuid'
    | '/tournaments/$tournamentUuid'
    | '/tournaments/$tournamentUuid/edit'
    | '/tournaments/mine'
    | '/admin/accounts/'
    | '/admin/bug-reports/'
    | '/global/decks/'
    | '/profile/'
    | '/tournaments/'
    | '/scan/live/$sessionUuid'
    | '/collaborating/$deckUuid/cards'
    | '/collaborating/$deckUuid/statistics'
    | '/collections/$collectionUuid/cards'
    | '/collections/$collectionUuid/on-loan'
    | '/collections/$collectionUuid/statistics'
    | '/decks/$deckUuid/advisor'
    | '/decks/$deckUuid/cards'
    | '/decks/$deckUuid/goldfish'
    | '/decks/$deckUuid/sourcing'
    | '/decks/$deckUuid/statistics'
    | '/global/collections/$collectionUuid'
    | '/global/decks/$deckUuid'
    | '/shared/collections/$token'
    | '/shared/decks/$token'
    | '/shared/tournaments/$token'
    | '/tournaments/$tournamentUuid/organizers'
    | '/tournaments/$tournamentUuid/participants'
    | '/tournaments/$tournamentUuid/rounds'
    | '/tournaments/$tournamentUuid/standings'
    | '/tournaments/$tournamentUuid/top-cut'
    | '/scan/live/'
    | '/collaborating/$deckUuid/'
    | '/collections/$collectionUuid/'
    | '/decks/$deckUuid/'
    | '/tournaments/$tournamentUuid/'
    | '/decks/$deckUuid/history/$changeUuid'
    | '/global/collections/$collectionUuid/cards'
    | '/global/collections/$collectionUuid/statistics'
    | '/global/decks/$deckUuid/cards'
    | '/global/decks/$deckUuid/statistics'
    | '/shared/collections/$token/cards'
    | '/shared/collections/$token/statistics'
    | '/shared/decks/$token/cards'
    | '/shared/decks/$token/statistics'
    | '/shared/tournaments/$token/participants'
    | '/shared/tournaments/$token/rounds'
    | '/shared/tournaments/$token/standings'
    | '/shared/tournaments/$token/top-cut'
    | '/tournaments/$tournamentUuid/matches/$matchUuid/life'
    | '/decks/$deckUuid/history/'
    | '/global/collections/$collectionUuid/'
    | '/global/decks/$deckUuid/'
    | '/shared/collections/$token/'
    | '/shared/decks/$token/'
    | '/shared/tournaments/$token/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/home'
    | '/legal'
    | '/privacy'
    | '/whats-new'
    | '/admin/log'
    | '/admin/statistics'
    | '/admin/syncs'
    | '/auth/login'
    | '/auth/register'
    | '/auth/signup'
    | '/auth/username'
    | '/game-utils/life-tracker'
    | '/game-utils/mpc-fill'
    | '/game-utils/proxy-printer'
    | '/scan/bench'
    | '/tournaments/create'
    | '/watch-lists/$watchListUuid'
    | '/admin'
    | '/collections'
    | '/decks'
    | '/game-utils'
    | '/scan'
    | '/watch-lists'
    | '/admin/accounts/$accountUuid'
    | '/admin/bug-reports/$number'
    | '/global/profiles/$username'
    | '/profile/security'
    | '/profile/settings'
    | '/scan/staged/$sessionUuid'
    | '/tournaments/$tournamentUuid/edit'
    | '/tournaments/mine'
    | '/admin/accounts'
    | '/admin/bug-reports'
    | '/global/decks'
    | '/profile'
    | '/tournaments'
    | '/scan/live/$sessionUuid'
    | '/collaborating/$deckUuid/cards'
    | '/collaborating/$deckUuid/statistics'
    | '/collections/$collectionUuid/cards'
    | '/collections/$collectionUuid/on-loan'
    | '/collections/$collectionUuid/statistics'
    | '/decks/$deckUuid/advisor'
    | '/decks/$deckUuid/cards'
    | '/decks/$deckUuid/goldfish'
    | '/decks/$deckUuid/sourcing'
    | '/decks/$deckUuid/statistics'
    | '/tournaments/$tournamentUuid/organizers'
    | '/tournaments/$tournamentUuid/participants'
    | '/tournaments/$tournamentUuid/rounds'
    | '/tournaments/$tournamentUuid/standings'
    | '/tournaments/$tournamentUuid/top-cut'
    | '/scan/live'
    | '/collaborating/$deckUuid'
    | '/collections/$collectionUuid'
    | '/decks/$deckUuid'
    | '/tournaments/$tournamentUuid'
    | '/decks/$deckUuid/history/$changeUuid'
    | '/global/collections/$collectionUuid/cards'
    | '/global/collections/$collectionUuid/statistics'
    | '/global/decks/$deckUuid/cards'
    | '/global/decks/$deckUuid/statistics'
    | '/shared/collections/$token/cards'
    | '/shared/collections/$token/statistics'
    | '/shared/decks/$token/cards'
    | '/shared/decks/$token/statistics'
    | '/shared/tournaments/$token/participants'
    | '/shared/tournaments/$token/rounds'
    | '/shared/tournaments/$token/standings'
    | '/shared/tournaments/$token/top-cut'
    | '/tournaments/$tournamentUuid/matches/$matchUuid/life'
    | '/decks/$deckUuid/history'
    | '/global/collections/$collectionUuid'
    | '/global/decks/$deckUuid'
    | '/shared/collections/$token'
    | '/shared/decks/$token'
    | '/shared/tournaments/$token'
  id:
    | '__root__'
    | '/_collect'
    | '/_menu'
    | '/_collect/_scan'
    | '/_menu/admin'
    | '/_menu/auth'
    | '/_menu/game-utils'
    | '/_menu/home'
    | '/_menu/legal'
    | '/_menu/privacy'
    | '/_menu/whats-new'
    | '/_menu/'
    | '/_menu/admin/log'
    | '/_menu/admin/statistics'
    | '/_menu/admin/syncs'
    | '/_menu/auth/login'
    | '/_menu/auth/register'
    | '/_menu/auth/signup'
    | '/_menu/auth/username'
    | '/_menu/game-utils/life-tracker'
    | '/_menu/game-utils/mpc-fill'
    | '/_menu/game-utils/proxy-printer'
    | '/_menu/profile/_profile'
    | '/_menu/scan/bench'
    | '/_menu/tournaments/_overview'
    | '/_menu/tournaments/create'
    | '/_menu/watch-lists/$watchListUuid'
    | '/_menu/admin/'
    | '/_menu/collections/'
    | '/_menu/decks/'
    | '/_menu/game-utils/'
    | '/_menu/scan/'
    | '/_menu/watch-lists/'
    | '/_menu/admin/accounts/$accountUuid'
    | '/_menu/admin/bug-reports/$number'
    | '/_menu/collaborating/$deckUuid/_deck'
    | '/_menu/collections/$collectionUuid/_collection'
    | '/_menu/decks/$deckUuid/_deck'
    | '/_menu/global/profiles/$username'
    | '/_menu/profile/_profile/security'
    | '/_menu/profile/_profile/settings'
    | '/_menu/scan/staged/$sessionUuid'
    | '/_menu/tournaments/$tournamentUuid/_tournament'
    | '/_menu/tournaments/$tournamentUuid/edit'
    | '/_menu/tournaments/_overview/mine'
    | '/_menu/admin/accounts/'
    | '/_menu/admin/bug-reports/'
    | '/_menu/global/decks/'
    | '/_menu/profile/_profile/'
    | '/_menu/tournaments/_overview/'
    | '/_collect/_scan/scan/live/$sessionUuid'
    | '/_menu/collaborating/$deckUuid/_deck/cards'
    | '/_menu/collaborating/$deckUuid/_deck/statistics'
    | '/_menu/collections/$collectionUuid/_collection/cards'
    | '/_menu/collections/$collectionUuid/_collection/on-loan'
    | '/_menu/collections/$collectionUuid/_collection/statistics'
    | '/_menu/decks/$deckUuid/_deck/advisor'
    | '/_menu/decks/$deckUuid/_deck/cards'
    | '/_menu/decks/$deckUuid/_deck/goldfish'
    | '/_menu/decks/$deckUuid/_deck/sourcing'
    | '/_menu/decks/$deckUuid/_deck/statistics'
    | '/_menu/global/collections/$collectionUuid/_collection'
    | '/_menu/global/decks/$deckUuid/_deck'
    | '/_menu/shared/collections/$token/_shared'
    | '/_menu/shared/decks/$token/_shared'
    | '/_menu/shared/tournaments/$token/_shared'
    | '/_menu/tournaments/$tournamentUuid/_tournament/organizers'
    | '/_menu/tournaments/$tournamentUuid/_tournament/participants'
    | '/_menu/tournaments/$tournamentUuid/_tournament/rounds'
    | '/_menu/tournaments/$tournamentUuid/_tournament/standings'
    | '/_menu/tournaments/$tournamentUuid/_tournament/top-cut'
    | '/_collect/_scan/scan/live/'
    | '/_menu/collaborating/$deckUuid/_deck/'
    | '/_menu/collections/$collectionUuid/_collection/'
    | '/_menu/decks/$deckUuid/_deck/'
    | '/_menu/tournaments/$tournamentUuid/_tournament/'
    | '/_menu/decks/$deckUuid/_deck/history/$changeUuid'
    | '/_menu/global/collections/$collectionUuid/_collection/cards'
    | '/_menu/global/collections/$collectionUuid/_collection/statistics'
    | '/_menu/global/decks/$deckUuid/_deck/cards'
    | '/_menu/global/decks/$deckUuid/_deck/statistics'
    | '/_menu/shared/collections/$token/_shared/cards'
    | '/_menu/shared/collections/$token/_shared/statistics'
    | '/_menu/shared/decks/$token/_shared/cards'
    | '/_menu/shared/decks/$token/_shared/statistics'
    | '/_menu/shared/tournaments/$token/_shared/participants'
    | '/_menu/shared/tournaments/$token/_shared/rounds'
    | '/_menu/shared/tournaments/$token/_shared/standings'
    | '/_menu/shared/tournaments/$token/_shared/top-cut'
    | '/_menu/tournaments/$tournamentUuid/matches/$matchUuid/life'
    | '/_menu/decks/$deckUuid/_deck/history/'
    | '/_menu/global/collections/$collectionUuid/_collection/'
    | '/_menu/global/decks/$deckUuid/_deck/'
    | '/_menu/shared/collections/$token/_shared/'
    | '/_menu/shared/decks/$token/_shared/'
    | '/_menu/shared/tournaments/$token/_shared/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  CollectRoute: typeof CollectRouteWithChildren
  MenuRoute: typeof MenuRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_collect': {
      id: '/_collect'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CollectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_menu': {
      id: '/_menu'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_collect/_scan': {
      id: '/_collect/_scan'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CollectScanRouteImport
      parentRoute: typeof CollectRoute
    }
    '/_menu/': {
      id: '/_menu/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof MenuIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/admin': {
      id: '/_menu/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof MenuAdminRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/auth': {
      id: '/_menu/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof MenuAuthRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/game-utils': {
      id: '/_menu/game-utils'
      path: '/game-utils'
      fullPath: '/game-utils'
      preLoaderRoute: typeof MenuGameUtilsRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/home': {
      id: '/_menu/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof MenuHomeRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/legal': {
      id: '/_menu/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof MenuLegalRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/privacy': {
      id: '/_menu/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof MenuPrivacyRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/whats-new': {
      id: '/_menu/whats-new'
      path: '/whats-new'
      fullPath: '/whats-new'
      preLoaderRoute: typeof MenuWhatsNewRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/admin/': {
      id: '/_menu/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof MenuAdminIndexRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/admin/log': {
      id: '/_menu/admin/log'
      path: '/log'
      fullPath: '/admin/log'
      preLoaderRoute: typeof MenuAdminLogRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/admin/statistics': {
      id: '/_menu/admin/statistics'
      path: '/statistics'
      fullPath: '/admin/statistics'
      preLoaderRoute: typeof MenuAdminStatisticsRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/admin/syncs': {
      id: '/_menu/admin/syncs'
      path: '/syncs'
      fullPath: '/admin/syncs'
      preLoaderRoute: typeof MenuAdminSyncsRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/auth/login': {
      id: '/_menu/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof MenuAuthLoginRouteImport
      parentRoute: typeof MenuAuthRoute
    }
    '/_menu/auth/register': {
      id: '/_menu/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof MenuAuthRegisterRouteImport
      parentRoute: typeof MenuAuthRoute
    }
    '/_menu/auth/signup': {
      id: '/_menu/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof MenuAuthSignupRouteImport
      parentRoute: typeof MenuAuthRoute
    }
    '/_menu/auth/username': {
      id: '/_menu/auth/username'
      path: '/username'
      fullPath: '/auth/username'
      preLoaderRoute: typeof MenuAuthUsernameRouteImport
      parentRoute: typeof MenuAuthRoute
    }
    '/_menu/collections/': {
      id: '/_menu/collections/'
      path: '/collections'
      fullPath: '/collections/'
      preLoaderRoute: typeof MenuCollectionsIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/decks/': {
      id: '/_menu/decks/'
      path: '/decks'
      fullPath: '/decks/'
      preLoaderRoute: typeof MenuDecksIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/game-utils/': {
      id: '/_menu/game-utils/'
      path: '/'
      fullPath: '/game-utils/'
      preLoaderRoute: typeof MenuGameUtilsIndexRouteImport
      parentRoute: typeof MenuGameUtilsRoute
    }
    '/_menu/game-utils/life-tracker': {
      id: '/_menu/game-utils/life-tracker'
      path: '/life-tracker'
      fullPath: '/game-utils/life-tracker'
      preLoaderRoute: typeof MenuGameUtilsLifeTrackerRouteImport
      parentRoute: typeof MenuGameUtilsRoute
    }
    '/_menu/game-utils/mpc-fill': {
      id: '/_menu/game-utils/mpc-fill'
      path: '/mpc-fill'
      fullPath: '/game-utils/mpc-fill'
      preLoaderRoute: typeof MenuGameUtilsMpcFillRouteImport
      parentRoute: typeof MenuGameUtilsRoute
    }
    '/_menu/game-utils/proxy-printer': {
      id: '/_menu/game-utils/proxy-printer'
      path: '/proxy-printer'
      fullPath: '/game-utils/proxy-printer'
      preLoaderRoute: typeof MenuGameUtilsProxyPrinterRouteImport
      parentRoute: typeof MenuGameUtilsRoute
    }
    '/_menu/profile/_profile': {
      id: '/_menu/profile/_profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof MenuProfileProfileRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/scan/': {
      id: '/_menu/scan/'
      path: '/scan'
      fullPath: '/scan/'
      preLoaderRoute: typeof MenuScanIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/scan/bench': {
      id: '/_menu/scan/bench'
      path: '/scan/bench'
      fullPath: '/scan/bench'
      preLoaderRoute: typeof MenuScanBenchRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/tournaments/_overview': {
      id: '/_menu/tournaments/_overview'
      path: '/tournaments'
      fullPath: '/tournaments'
      preLoaderRoute: typeof MenuTournamentsOverviewRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/tournaments/create': {
      id: '/_menu/tournaments/create'
      path: '/tournaments/create'
      fullPath: '/tournaments/create'
      preLoaderRoute: typeof MenuTournamentsCreateRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/watch-lists/': {
      id: '/_menu/watch-lists/'
      path: '/watch-lists'
      fullPath: '/watch-lists/'
      preLoaderRoute: typeof MenuWatchListsIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/watch-lists/$watchListUuid': {
      id: '/_menu/watch-lists/$watchListUuid'
      path: '/watch-lists/$watchListUuid'
      fullPath: '/watch-lists/$watchListUuid'
      preLoaderRoute: typeof MenuWatchListsWatchListUuidRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/admin/accounts/': {
      id: '/_menu/admin/accounts/'
      path: '/accounts'
      fullPath: '/admin/accounts/'
      preLoaderRoute: typeof MenuAdminAccountsIndexRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/admin/accounts/$accountUuid': {
      id: '/_menu/admin/accounts/$accountUuid'
      path: '/accounts/$accountUuid'
      fullPath: '/admin/accounts/$accountUuid'
      preLoaderRoute: typeof MenuAdminAccountsAccountUuidRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/admin/bug-reports/': {
      id: '/_menu/admin/bug-reports/'
      path: '/bug-reports'
      fullPath: '/admin/bug-reports/'
      preLoaderRoute: typeof MenuAdminBugReportsIndexRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/admin/bug-reports/$number': {
      id: '/_menu/admin/bug-reports/$number'
      path: '/bug-reports/$number'
      fullPath: '/admin/bug-reports/$number'
      preLoaderRoute: typeof MenuAdminBugReportsNumberRouteImport
      parentRoute: typeof MenuAdminRoute
    }
    '/_menu/collaborating/$deckUuid/_deck': {
      id: '/_menu/collaborating/$deckUuid/_deck'
      path: '/collaborating/$deckUuid'
      fullPath: '/collaborating/$deckUuid'
      preLoaderRoute: typeof MenuCollaboratingDeckUuidDeckRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/collections/$collectionUuid/_collection': {
      id: '/_menu/collections/$collectionUuid/_collection'
      path: '/collections/$collectionUuid'
      fullPath: '/collections/$collectionUuid'
      preLoaderRoute: typeof MenuCollectionsCollectionUuidCollectionRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/decks/$deckUuid/_deck': {
      id: '/_menu/decks/$deckUuid/_deck'
      path: '/decks/$deckUuid'
      fullPath: '/decks/$deckUuid'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/global/decks/': {
      id: '/_menu/global/decks/'
      path: '/global/decks'
      fullPath: '/global/decks/'
      preLoaderRoute: typeof MenuGlobalDecksIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/global/profiles/$username': {
      id: '/_menu/global/profiles/$username'
      path: '/global/profiles/$username'
      fullPath: '/global/profiles/$username'
      preLoaderRoute: typeof MenuGlobalProfilesUsernameRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/profile/_profile/': {
      id: '/_menu/profile/_profile/'
      path: '/'
      fullPath: '/profile/'
      preLoaderRoute: typeof MenuProfileProfileIndexRouteImport
      parentRoute: typeof MenuProfileProfileRoute
    }
    '/_menu/profile/_profile/security': {
      id: '/_menu/profile/_profile/security'
      path: '/security'
      fullPath: '/profile/security'
      preLoaderRoute: typeof MenuProfileProfileSecurityRouteImport
      parentRoute: typeof MenuProfileProfileRoute
    }
    '/_menu/profile/_profile/settings': {
      id: '/_menu/profile/_profile/settings'
      path: '/settings'
      fullPath: '/profile/settings'
      preLoaderRoute: typeof MenuProfileProfileSettingsRouteImport
      parentRoute: typeof MenuProfileProfileRoute
    }
    '/_menu/scan/staged/$sessionUuid': {
      id: '/_menu/scan/staged/$sessionUuid'
      path: '/scan/staged/$sessionUuid'
      fullPath: '/scan/staged/$sessionUuid'
      preLoaderRoute: typeof MenuScanStagedSessionUuidRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/tournaments/$tournamentUuid/_tournament': {
      id: '/_menu/tournaments/$tournamentUuid/_tournament'
      path: '/tournaments/$tournamentUuid'
      fullPath: '/tournaments/$tournamentUuid'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidTournamentRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/tournaments/$tournamentUuid/edit': {
      id: '/_menu/tournaments/$tournamentUuid/edit'
      path: '/tournaments/$tournamentUuid/edit'
      fullPath: '/tournaments/$tournamentUuid/edit'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidEditRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/tournaments/_overview/': {
      id: '/_menu/tournaments/_overview/'
      path: '/'
      fullPath: '/tournaments/'
      preLoaderRoute: typeof MenuTournamentsOverviewIndexRouteImport
      parentRoute: typeof MenuTournamentsOverviewRoute
    }
    '/_menu/tournaments/_overview/mine': {
      id: '/_menu/tournaments/_overview/mine'
      path: '/mine'
      fullPath: '/tournaments/mine'
      preLoaderRoute: typeof MenuTournamentsOverviewMineRouteImport
      parentRoute: typeof MenuTournamentsOverviewRoute
    }
    '/_collect/_scan/scan/live/': {
      id: '/_collect/_scan/scan/live/'
      path: '/scan/live'
      fullPath: '/scan/live/'
      preLoaderRoute: typeof CollectScanScanLiveIndexRouteImport
      parentRoute: typeof CollectScanRoute
    }
    '/_collect/_scan/scan/live/$sessionUuid': {
      id: '/_collect/_scan/scan/live/$sessionUuid'
      path: '/scan/live/$sessionUuid'
      fullPath: '/scan/live/$sessionUuid'
      preLoaderRoute: typeof CollectScanScanLiveSessionUuidRouteImport
      parentRoute: typeof CollectScanRoute
    }
    '/_menu/collaborating/$deckUuid/_deck/': {
      id: '/_menu/collaborating/$deckUuid/_deck/'
      path: '/'
      fullPath: '/collaborating/$deckUuid/'
      preLoaderRoute: typeof MenuCollaboratingDeckUuidDeckIndexRouteImport
      parentRoute: typeof MenuCollaboratingDeckUuidDeckRoute
    }
    '/_menu/collaborating/$deckUuid/_deck/cards': {
      id: '/_menu/collaborating/$deckUuid/_deck/cards'
      path: '/cards'
      fullPath: '/collaborating/$deckUuid/cards'
      preLoaderRoute: typeof MenuCollaboratingDeckUuidDeckCardsRouteImport
      parentRoute: typeof MenuCollaboratingDeckUuidDeckRoute
    }
    '/_menu/collaborating/$deckUuid/_deck/statistics': {
      id: '/_menu/collaborating/$deckUuid/_deck/statistics'
      path: '/statistics'
      fullPath: '/collaborating/$deckUuid/statistics'
      preLoaderRoute: typeof MenuCollaboratingDeckUuidDeckStatisticsRouteImport
      parentRoute: typeof MenuCollaboratingDeckUuidDeckRoute
    }
    '/_menu/collections/$collectionUuid/_collection/': {
      id: '/_menu/collections/$collectionUuid/_collection/'
      path: '/'
      fullPath: '/collections/$collectionUuid/'
      preLoaderRoute: typeof MenuCollectionsCollectionUuidCollectionIndexRouteImport
      parentRoute: typeof MenuCollectionsCollectionUuidCollectionRoute
    }
    '/_menu/collections/$collectionUuid/_collection/cards': {
      id: '/_menu/collections/$collectionUuid/_collection/cards'
      path: '/cards'
      fullPath: '/collections/$collectionUuid/cards'
      preLoaderRoute: typeof MenuCollectionsCollectionUuidCollectionCardsRouteImport
      parentRoute: typeof MenuCollectionsCollectionUuidCollectionRoute
    }
    '/_menu/collections/$collectionUuid/_collection/on-loan': {
      id: '/_menu/collections/$collectionUuid/_collection/on-loan'
      path: '/on-loan'
      fullPath: '/collections/$collectionUuid/on-loan'
      preLoaderRoute: typeof MenuCollectionsCollectionUuidCollectionOnLoanRouteImport
      parentRoute: typeof MenuCollectionsCollectionUuidCollectionRoute
    }
    '/_menu/collections/$collectionUuid/_collection/statistics': {
      id: '/_menu/collections/$collectionUuid/_collection/statistics'
      path: '/statistics'
      fullPath: '/collections/$collectionUuid/statistics'
      preLoaderRoute: typeof MenuCollectionsCollectionUuidCollectionStatisticsRouteImport
      parentRoute: typeof MenuCollectionsCollectionUuidCollectionRoute
    }
    '/_menu/decks/$deckUuid/_deck/': {
      id: '/_menu/decks/$deckUuid/_deck/'
      path: '/'
      fullPath: '/decks/$deckUuid/'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckIndexRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/decks/$deckUuid/_deck/advisor': {
      id: '/_menu/decks/$deckUuid/_deck/advisor'
      path: '/advisor'
      fullPath: '/decks/$deckUuid/advisor'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckAdvisorRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/decks/$deckUuid/_deck/cards': {
      id: '/_menu/decks/$deckUuid/_deck/cards'
      path: '/cards'
      fullPath: '/decks/$deckUuid/cards'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckCardsRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/decks/$deckUuid/_deck/goldfish': {
      id: '/_menu/decks/$deckUuid/_deck/goldfish'
      path: '/goldfish'
      fullPath: '/decks/$deckUuid/goldfish'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckGoldfishRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/decks/$deckUuid/_deck/sourcing': {
      id: '/_menu/decks/$deckUuid/_deck/sourcing'
      path: '/sourcing'
      fullPath: '/decks/$deckUuid/sourcing'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckSourcingRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/decks/$deckUuid/_deck/statistics': {
      id: '/_menu/decks/$deckUuid/_deck/statistics'
      path: '/statistics'
      fullPath: '/decks/$deckUuid/statistics'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckStatisticsRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/global/collections/$collectionUuid/_collection': {
      id: '/_menu/global/collections/$collectionUuid/_collection'
      path: '/global/collections/$collectionUuid'
      fullPath: '/global/collections/$collectionUuid'
      preLoaderRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/global/decks/$deckUuid/_deck': {
      id: '/_menu/global/decks/$deckUuid/_deck'
      path: '/global/decks/$deckUuid'
      fullPath: '/global/decks/$deckUuid'
      preLoaderRoute: typeof MenuGlobalDecksDeckUuidDeckRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/shared/collections/$token/_shared': {
      id: '/_menu/shared/collections/$token/_shared'
      path: '/shared/collections/$token'
      fullPath: '/shared/collections/$token'
      preLoaderRoute: typeof MenuSharedCollectionsTokenSharedRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/shared/decks/$token/_shared': {
      id: '/_menu/shared/decks/$token/_shared'
      path: '/shared/decks/$token'
      fullPath: '/shared/decks/$token'
      preLoaderRoute: typeof MenuSharedDecksTokenSharedRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/shared/tournaments/$token/_shared': {
      id: '/_menu/shared/tournaments/$token/_shared'
      path: '/shared/tournaments/$token'
      fullPath: '/shared/tournaments/$token'
      preLoaderRoute: typeof MenuSharedTournamentsTokenSharedRouteImport
      parentRoute: typeof MenuRoute
    }
    '/_menu/tournaments/$tournamentUuid/_tournament/': {
      id: '/_menu/tournaments/$tournamentUuid/_tournament/'
      path: '/'
      fullPath: '/tournaments/$tournamentUuid/'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidTournamentIndexRouteImport
      parentRoute: typeof MenuTournamentsTournamentUuidTournamentRoute
    }
    '/_menu/tournaments/$tournamentUuid/_tournament/organizers': {
      id: '/_menu/tournaments/$tournamentUuid/_tournament/organizers'
      path: '/organizers'
      fullPath: '/tournaments/$tournamentUuid/organizers'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidTournamentOrganizersRouteImport
      parentRoute: typeof MenuTournamentsTournamentUuidTournamentRoute
    }
    '/_menu/tournaments/$tournamentUuid/_tournament/participants': {
      id: '/_menu/tournaments/$tournamentUuid/_tournament/participants'
      path: '/participants'
      fullPath: '/tournaments/$tournamentUuid/participants'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidTournamentParticipantsRouteImport
      parentRoute: typeof MenuTournamentsTournamentUuidTournamentRoute
    }
    '/_menu/tournaments/$tournamentUuid/_tournament/rounds': {
      id: '/_menu/tournaments/$tournamentUuid/_tournament/rounds'
      path: '/rounds'
      fullPath: '/tournaments/$tournamentUuid/rounds'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidTournamentRoundsRouteImport
      parentRoute: typeof MenuTournamentsTournamentUuidTournamentRoute
    }
    '/_menu/tournaments/$tournamentUuid/_tournament/standings': {
      id: '/_menu/tournaments/$tournamentUuid/_tournament/standings'
      path: '/standings'
      fullPath: '/tournaments/$tournamentUuid/standings'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidTournamentStandingsRouteImport
      parentRoute: typeof MenuTournamentsTournamentUuidTournamentRoute
    }
    '/_menu/tournaments/$tournamentUuid/_tournament/top-cut': {
      id: '/_menu/tournaments/$tournamentUuid/_tournament/top-cut'
      path: '/top-cut'
      fullPath: '/tournaments/$tournamentUuid/top-cut'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidTournamentTopCutRouteImport
      parentRoute: typeof MenuTournamentsTournamentUuidTournamentRoute
    }
    '/_menu/decks/$deckUuid/_deck/history/': {
      id: '/_menu/decks/$deckUuid/_deck/history/'
      path: '/history'
      fullPath: '/decks/$deckUuid/history/'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckHistoryIndexRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/decks/$deckUuid/_deck/history/$changeUuid': {
      id: '/_menu/decks/$deckUuid/_deck/history/$changeUuid'
      path: '/history/$changeUuid'
      fullPath: '/decks/$deckUuid/history/$changeUuid'
      preLoaderRoute: typeof MenuDecksDeckUuidDeckHistoryChangeUuidRouteImport
      parentRoute: typeof MenuDecksDeckUuidDeckRoute
    }
    '/_menu/global/collections/$collectionUuid/_collection/': {
      id: '/_menu/global/collections/$collectionUuid/_collection/'
      path: '/'
      fullPath: '/global/collections/$collectionUuid/'
      preLoaderRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionIndexRouteImport
      parentRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionRoute
    }
    '/_menu/global/collections/$collectionUuid/_collection/cards': {
      id: '/_menu/global/collections/$collectionUuid/_collection/cards'
      path: '/cards'
      fullPath: '/global/collections/$collectionUuid/cards'
      preLoaderRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionCardsRouteImport
      parentRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionRoute
    }
    '/_menu/global/collections/$collectionUuid/_collection/statistics': {
      id: '/_menu/global/collections/$collectionUuid/_collection/statistics'
      path: '/statistics'
      fullPath: '/global/collections/$collectionUuid/statistics'
      preLoaderRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionStatisticsRouteImport
      parentRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionRoute
    }
    '/_menu/global/decks/$deckUuid/_deck/': {
      id: '/_menu/global/decks/$deckUuid/_deck/'
      path: '/'
      fullPath: '/global/decks/$deckUuid/'
      preLoaderRoute: typeof MenuGlobalDecksDeckUuidDeckIndexRouteImport
      parentRoute: typeof MenuGlobalDecksDeckUuidDeckRoute
    }
    '/_menu/global/decks/$deckUuid/_deck/cards': {
      id: '/_menu/global/decks/$deckUuid/_deck/cards'
      path: '/cards'
      fullPath: '/global/decks/$deckUuid/cards'
      preLoaderRoute: typeof MenuGlobalDecksDeckUuidDeckCardsRouteImport
      parentRoute: typeof MenuGlobalDecksDeckUuidDeckRoute
    }
    '/_menu/global/decks/$deckUuid/_deck/statistics': {
      id: '/_menu/global/decks/$deckUuid/_deck/statistics'
      path: '/statistics'
      fullPath: '/global/decks/$deckUuid/statistics'
      preLoaderRoute: typeof MenuGlobalDecksDeckUuidDeckStatisticsRouteImport
      parentRoute: typeof MenuGlobalDecksDeckUuidDeckRoute
    }
    '/_menu/shared/collections/$token/_shared/': {
      id: '/_menu/shared/collections/$token/_shared/'
      path: '/'
      fullPath: '/shared/collections/$token/'
      preLoaderRoute: typeof MenuSharedCollectionsTokenSharedIndexRouteImport
      parentRoute: typeof MenuSharedCollectionsTokenSharedRoute
    }
    '/_menu/shared/collections/$token/_shared/cards': {
      id: '/_menu/shared/collections/$token/_shared/cards'
      path: '/cards'
      fullPath: '/shared/collections/$token/cards'
      preLoaderRoute: typeof MenuSharedCollectionsTokenSharedCardsRouteImport
      parentRoute: typeof MenuSharedCollectionsTokenSharedRoute
    }
    '/_menu/shared/collections/$token/_shared/statistics': {
      id: '/_menu/shared/collections/$token/_shared/statistics'
      path: '/statistics'
      fullPath: '/shared/collections/$token/statistics'
      preLoaderRoute: typeof MenuSharedCollectionsTokenSharedStatisticsRouteImport
      parentRoute: typeof MenuSharedCollectionsTokenSharedRoute
    }
    '/_menu/shared/decks/$token/_shared/': {
      id: '/_menu/shared/decks/$token/_shared/'
      path: '/'
      fullPath: '/shared/decks/$token/'
      preLoaderRoute: typeof MenuSharedDecksTokenSharedIndexRouteImport
      parentRoute: typeof MenuSharedDecksTokenSharedRoute
    }
    '/_menu/shared/decks/$token/_shared/cards': {
      id: '/_menu/shared/decks/$token/_shared/cards'
      path: '/cards'
      fullPath: '/shared/decks/$token/cards'
      preLoaderRoute: typeof MenuSharedDecksTokenSharedCardsRouteImport
      parentRoute: typeof MenuSharedDecksTokenSharedRoute
    }
    '/_menu/shared/decks/$token/_shared/statistics': {
      id: '/_menu/shared/decks/$token/_shared/statistics'
      path: '/statistics'
      fullPath: '/shared/decks/$token/statistics'
      preLoaderRoute: typeof MenuSharedDecksTokenSharedStatisticsRouteImport
      parentRoute: typeof MenuSharedDecksTokenSharedRoute
    }
    '/_menu/shared/tournaments/$token/_shared/': {
      id: '/_menu/shared/tournaments/$token/_shared/'
      path: '/'
      fullPath: '/shared/tournaments/$token/'
      preLoaderRoute: typeof MenuSharedTournamentsTokenSharedIndexRouteImport
      parentRoute: typeof MenuSharedTournamentsTokenSharedRoute
    }
    '/_menu/shared/tournaments/$token/_shared/participants': {
      id: '/_menu/shared/tournaments/$token/_shared/participants'
      path: '/participants'
      fullPath: '/shared/tournaments/$token/participants'
      preLoaderRoute: typeof MenuSharedTournamentsTokenSharedParticipantsRouteImport
      parentRoute: typeof MenuSharedTournamentsTokenSharedRoute
    }
    '/_menu/shared/tournaments/$token/_shared/rounds': {
      id: '/_menu/shared/tournaments/$token/_shared/rounds'
      path: '/rounds'
      fullPath: '/shared/tournaments/$token/rounds'
      preLoaderRoute: typeof MenuSharedTournamentsTokenSharedRoundsRouteImport
      parentRoute: typeof MenuSharedTournamentsTokenSharedRoute
    }
    '/_menu/shared/tournaments/$token/_shared/standings': {
      id: '/_menu/shared/tournaments/$token/_shared/standings'
      path: '/standings'
      fullPath: '/shared/tournaments/$token/standings'
      preLoaderRoute: typeof MenuSharedTournamentsTokenSharedStandingsRouteImport
      parentRoute: typeof MenuSharedTournamentsTokenSharedRoute
    }
    '/_menu/shared/tournaments/$token/_shared/top-cut': {
      id: '/_menu/shared/tournaments/$token/_shared/top-cut'
      path: '/top-cut'
      fullPath: '/shared/tournaments/$token/top-cut'
      preLoaderRoute: typeof MenuSharedTournamentsTokenSharedTopCutRouteImport
      parentRoute: typeof MenuSharedTournamentsTokenSharedRoute
    }
    '/_menu/tournaments/$tournamentUuid/matches/$matchUuid/life': {
      id: '/_menu/tournaments/$tournamentUuid/matches/$matchUuid/life'
      path: '/tournaments/$tournamentUuid/matches/$matchUuid/life'
      fullPath: '/tournaments/$tournamentUuid/matches/$matchUuid/life'
      preLoaderRoute: typeof MenuTournamentsTournamentUuidMatchesMatchUuidLifeRouteImport
      parentRoute: typeof MenuRoute
    }
  }
}

interface CollectScanRouteChildren {
  CollectScanScanLiveSessionUuidRoute: typeof CollectScanScanLiveSessionUuidRoute
  CollectScanScanLiveIndexRoute: typeof CollectScanScanLiveIndexRoute
}

const CollectScanRouteChildren: CollectScanRouteChildren = {
  CollectScanScanLiveSessionUuidRoute: CollectScanScanLiveSessionUuidRoute,
  CollectScanScanLiveIndexRoute: CollectScanScanLiveIndexRoute,
}

const CollectScanRouteWithChildren = CollectScanRoute._addFileChildren(
  CollectScanRouteChildren,
)

interface CollectRouteChildren {
  CollectScanRoute: typeof CollectScanRouteWithChildren
}

const CollectRouteChildren: CollectRouteChildren = {
  CollectScanRoute: CollectScanRouteWithChildren,
}

const CollectRouteWithChildren =
  CollectRoute._addFileChildren(CollectRouteChildren)

interface MenuAdminRouteChildren {
  MenuAdminLogRoute: typeof MenuAdminLogRoute
  MenuAdminStatisticsRoute: typeof MenuAdminStatisticsRoute
  MenuAdminSyncsRoute: typeof MenuAdminSyncsRoute
  MenuAdminIndexRoute: typeof MenuAdminIndexRoute
  MenuAdminAccountsAccountUuidRoute: typeof MenuAdminAccountsAccountUuidRoute
  MenuAdminBugReportsNumberRoute: typeof MenuAdminBugReportsNumberRoute
  MenuAdminAccountsIndexRoute: typeof MenuAdminAccountsIndexRoute
  MenuAdminBugReportsIndexRoute: typeof MenuAdminBugReportsIndexRoute
}

const MenuAdminRouteChildren: MenuAdminRouteChildren = {
  MenuAdminLogRoute: MenuAdminLogRoute,
  MenuAdminStatisticsRoute: MenuAdminStatisticsRoute,
  MenuAdminSyncsRoute: MenuAdminSyncsRoute,
  MenuAdminIndexRoute: MenuAdminIndexRoute,
  MenuAdminAccountsAccountUuidRoute: MenuAdminAccountsAccountUuidRoute,
  MenuAdminBugReportsNumberRoute: MenuAdminBugReportsNumberRoute,
  MenuAdminAccountsIndexRoute: MenuAdminAccountsIndexRoute,
  MenuAdminBugReportsIndexRoute: MenuAdminBugReportsIndexRoute,
}

const MenuAdminRouteWithChildren = MenuAdminRoute._addFileChildren(
  MenuAdminRouteChildren,
)

interface MenuAuthRouteChildren {
  MenuAuthLoginRoute: typeof MenuAuthLoginRoute
  MenuAuthRegisterRoute: typeof MenuAuthRegisterRoute
  MenuAuthSignupRoute: typeof MenuAuthSignupRoute
  MenuAuthUsernameRoute: typeof MenuAuthUsernameRoute
}

const MenuAuthRouteChildren: MenuAuthRouteChildren = {
  MenuAuthLoginRoute: MenuAuthLoginRoute,
  MenuAuthRegisterRoute: MenuAuthRegisterRoute,
  MenuAuthSignupRoute: MenuAuthSignupRoute,
  MenuAuthUsernameRoute: MenuAuthUsernameRoute,
}

const MenuAuthRouteWithChildren = MenuAuthRoute._addFileChildren(
  MenuAuthRouteChildren,
)

interface MenuGameUtilsRouteChildren {
  MenuGameUtilsLifeTrackerRoute: typeof MenuGameUtilsLifeTrackerRoute
  MenuGameUtilsMpcFillRoute: typeof MenuGameUtilsMpcFillRoute
  MenuGameUtilsProxyPrinterRoute: typeof MenuGameUtilsProxyPrinterRoute
  MenuGameUtilsIndexRoute: typeof MenuGameUtilsIndexRoute
}

const MenuGameUtilsRouteChildren: MenuGameUtilsRouteChildren = {
  MenuGameUtilsLifeTrackerRoute: MenuGameUtilsLifeTrackerRoute,
  MenuGameUtilsMpcFillRoute: MenuGameUtilsMpcFillRoute,
  MenuGameUtilsProxyPrinterRoute: MenuGameUtilsProxyPrinterRoute,
  MenuGameUtilsIndexRoute: MenuGameUtilsIndexRoute,
}

const MenuGameUtilsRouteWithChildren = MenuGameUtilsRoute._addFileChildren(
  MenuGameUtilsRouteChildren,
)

interface MenuProfileProfileRouteChildren {
  MenuProfileProfileSecurityRoute: typeof MenuProfileProfileSecurityRoute
  MenuProfileProfileSettingsRoute: typeof MenuProfileProfileSettingsRoute
  MenuProfileProfileIndexRoute: typeof MenuProfileProfileIndexRoute
}

const MenuProfileProfileRouteChildren: MenuProfileProfileRouteChildren = {
  MenuProfileProfileSecurityRoute: MenuProfileProfileSecurityRoute,
  MenuProfileProfileSettingsRoute: MenuProfileProfileSettingsRoute,
  MenuProfileProfileIndexRoute: MenuProfileProfileIndexRoute,
}

const MenuProfileProfileRouteWithChildren =
  MenuProfileProfileRoute._addFileChildren(MenuProfileProfileRouteChildren)

interface MenuTournamentsOverviewRouteChildren {
  MenuTournamentsOverviewMineRoute: typeof MenuTournamentsOverviewMineRoute
  MenuTournamentsOverviewIndexRoute: typeof MenuTournamentsOverviewIndexRoute
}

const MenuTournamentsOverviewRouteChildren: MenuTournamentsOverviewRouteChildren =
  {
    MenuTournamentsOverviewMineRoute: MenuTournamentsOverviewMineRoute,
    MenuTournamentsOverviewIndexRoute: MenuTournamentsOverviewIndexRoute,
  }

const MenuTournamentsOverviewRouteWithChildren =
  MenuTournamentsOverviewRoute._addFileChildren(
    MenuTournamentsOverviewRouteChildren,
  )

interface MenuCollaboratingDeckUuidDeckRouteChildren {
  MenuCollaboratingDeckUuidDeckCardsRoute: typeof MenuCollaboratingDeckUuidDeckCardsRoute
  MenuCollaboratingDeckUuidDeckStatisticsRoute: typeof MenuCollaboratingDeckUuidDeckStatisticsRoute
  MenuCollaboratingDeckUuidDeckIndexRoute: typeof MenuCollaboratingDeckUuidDeckIndexRoute
}

const MenuCollaboratingDeckUuidDeckRouteChildren: MenuCollaboratingDeckUuidDeckRouteChildren =
  {
    MenuCollaboratingDeckUuidDeckCardsRoute:
      MenuCollaboratingDeckUuidDeckCardsRoute,
    MenuCollaboratingDeckUuidDeckStatisticsRoute:
      MenuCollaboratingDeckUuidDeckStatisticsRoute,
    MenuCollaboratingDeckUuidDeckIndexRoute:
      MenuCollaboratingDeckUuidDeckIndexRoute,
  }

const MenuCollaboratingDeckUuidDeckRouteWithChildren =
  MenuCollaboratingDeckUuidDeckRoute._addFileChildren(
    MenuCollaboratingDeckUuidDeckRouteChildren,
  )

interface MenuCollectionsCollectionUuidCollectionRouteChildren {
  MenuCollectionsCollectionUuidCollectionCardsRoute: typeof MenuCollectionsCollectionUuidCollectionCardsRoute
  MenuCollectionsCollectionUuidCollectionOnLoanRoute: typeof MenuCollectionsCollectionUuidCollectionOnLoanRoute
  MenuCollectionsCollectionUuidCollectionStatisticsRoute: typeof MenuCollectionsCollectionUuidCollectionStatisticsRoute
  MenuCollectionsCollectionUuidCollectionIndexRoute: typeof MenuCollectionsCollectionUuidCollectionIndexRoute
}

const MenuCollectionsCollectionUuidCollectionRouteChildren: MenuCollectionsCollectionUuidCollectionRouteChildren =
  {
    MenuCollectionsCollectionUuidCollectionCardsRoute:
      MenuCollectionsCollectionUuidCollectionCardsRoute,
    MenuCollectionsCollectionUuidCollectionOnLoanRoute:
      MenuCollectionsCollectionUuidCollectionOnLoanRoute,
    MenuCollectionsCollectionUuidCollectionStatisticsRoute:
      MenuCollectionsCollectionUuidCollectionStatisticsRoute,
    MenuCollectionsCollectionUuidCollectionIndexRoute:
      MenuCollectionsCollectionUuidCollectionIndexRoute,
  }

const MenuCollectionsCollectionUuidCollectionRouteWithChildren =
  MenuCollectionsCollectionUuidCollectionRoute._addFileChildren(
    MenuCollectionsCollectionUuidCollectionRouteChildren,
  )

interface MenuDecksDeckUuidDeckRouteChildren {
  MenuDecksDeckUuidDeckAdvisorRoute: typeof MenuDecksDeckUuidDeckAdvisorRoute
  MenuDecksDeckUuidDeckCardsRoute: typeof MenuDecksDeckUuidDeckCardsRoute
  MenuDecksDeckUuidDeckGoldfishRoute: typeof MenuDecksDeckUuidDeckGoldfishRoute
  MenuDecksDeckUuidDeckSourcingRoute: typeof MenuDecksDeckUuidDeckSourcingRoute
  MenuDecksDeckUuidDeckStatisticsRoute: typeof MenuDecksDeckUuidDeckStatisticsRoute
  MenuDecksDeckUuidDeckIndexRoute: typeof MenuDecksDeckUuidDeckIndexRoute
  MenuDecksDeckUuidDeckHistoryChangeUuidRoute: typeof MenuDecksDeckUuidDeckHistoryChangeUuidRoute
  MenuDecksDeckUuidDeckHistoryIndexRoute: typeof MenuDecksDeckUuidDeckHistoryIndexRoute
}

const MenuDecksDeckUuidDeckRouteChildren: MenuDecksDeckUuidDeckRouteChildren = {
  MenuDecksDeckUuidDeckAdvisorRoute: MenuDecksDeckUuidDeckAdvisorRoute,
  MenuDecksDeckUuidDeckCardsRoute: MenuDecksDeckUuidDeckCardsRoute,
  MenuDecksDeckUuidDeckGoldfishRoute: MenuDecksDeckUuidDeckGoldfishRoute,
  MenuDecksDeckUuidDeckSourcingRoute: MenuDecksDeckUuidDeckSourcingRoute,
  MenuDecksDeckUuidDeckStatisticsRoute: MenuDecksDeckUuidDeckStatisticsRoute,
  MenuDecksDeckUuidDeckIndexRoute: MenuDecksDeckUuidDeckIndexRoute,
  MenuDecksDeckUuidDeckHistoryChangeUuidRoute:
    MenuDecksDeckUuidDeckHistoryChangeUuidRoute,
  MenuDecksDeckUuidDeckHistoryIndexRoute:
    MenuDecksDeckUuidDeckHistoryIndexRoute,
}

const MenuDecksDeckUuidDeckRouteWithChildren =
  MenuDecksDeckUuidDeckRoute._addFileChildren(
    MenuDecksDeckUuidDeckRouteChildren,
  )

interface MenuTournamentsTournamentUuidTournamentRouteChildren {
  MenuTournamentsTournamentUuidTournamentOrganizersRoute: typeof MenuTournamentsTournamentUuidTournamentOrganizersRoute
  MenuTournamentsTournamentUuidTournamentParticipantsRoute: typeof MenuTournamentsTournamentUuidTournamentParticipantsRoute
  MenuTournamentsTournamentUuidTournamentRoundsRoute: typeof MenuTournamentsTournamentUuidTournamentRoundsRoute
  MenuTournamentsTournamentUuidTournamentStandingsRoute: typeof MenuTournamentsTournamentUuidTournamentStandingsRoute
  MenuTournamentsTournamentUuidTournamentTopCutRoute: typeof MenuTournamentsTournamentUuidTournamentTopCutRoute
  MenuTournamentsTournamentUuidTournamentIndexRoute: typeof MenuTournamentsTournamentUuidTournamentIndexRoute
}

const MenuTournamentsTournamentUuidTournamentRouteChildren: MenuTournamentsTournamentUuidTournamentRouteChildren =
  {
    MenuTournamentsTournamentUuidTournamentOrganizersRoute:
      MenuTournamentsTournamentUuidTournamentOrganizersRoute,
    MenuTournamentsTournamentUuidTournamentParticipantsRoute:
      MenuTournamentsTournamentUuidTournamentParticipantsRoute,
    MenuTournamentsTournamentUuidTournamentRoundsRoute:
      MenuTournamentsTournamentUuidTournamentRoundsRoute,
    MenuTournamentsTournamentUuidTournamentStandingsRoute:
      MenuTournamentsTournamentUuidTournamentStandingsRoute,
    MenuTournamentsTournamentUuidTournamentTopCutRoute:
      MenuTournamentsTournamentUuidTournamentTopCutRoute,
    MenuTournamentsTournamentUuidTournamentIndexRoute:
      MenuTournamentsTournamentUuidTournamentIndexRoute,
  }

const MenuTournamentsTournamentUuidTournamentRouteWithChildren =
  MenuTournamentsTournamentUuidTournamentRoute._addFileChildren(
    MenuTournamentsTournamentUuidTournamentRouteChildren,
  )

interface MenuGlobalCollectionsCollectionUuidCollectionRouteChildren {
  MenuGlobalCollectionsCollectionUuidCollectionCardsRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionCardsRoute
  MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute
  MenuGlobalCollectionsCollectionUuidCollectionIndexRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionIndexRoute
}

const MenuGlobalCollectionsCollectionUuidCollectionRouteChildren: MenuGlobalCollectionsCollectionUuidCollectionRouteChildren =
  {
    MenuGlobalCollectionsCollectionUuidCollectionCardsRoute:
      MenuGlobalCollectionsCollectionUuidCollectionCardsRoute,
    MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute:
      MenuGlobalCollectionsCollectionUuidCollectionStatisticsRoute,
    MenuGlobalCollectionsCollectionUuidCollectionIndexRoute:
      MenuGlobalCollectionsCollectionUuidCollectionIndexRoute,
  }

const MenuGlobalCollectionsCollectionUuidCollectionRouteWithChildren =
  MenuGlobalCollectionsCollectionUuidCollectionRoute._addFileChildren(
    MenuGlobalCollectionsCollectionUuidCollectionRouteChildren,
  )

interface MenuGlobalDecksDeckUuidDeckRouteChildren {
  MenuGlobalDecksDeckUuidDeckCardsRoute: typeof MenuGlobalDecksDeckUuidDeckCardsRoute
  MenuGlobalDecksDeckUuidDeckStatisticsRoute: typeof MenuGlobalDecksDeckUuidDeckStatisticsRoute
  MenuGlobalDecksDeckUuidDeckIndexRoute: typeof MenuGlobalDecksDeckUuidDeckIndexRoute
}

const MenuGlobalDecksDeckUuidDeckRouteChildren: MenuGlobalDecksDeckUuidDeckRouteChildren =
  {
    MenuGlobalDecksDeckUuidDeckCardsRoute:
      MenuGlobalDecksDeckUuidDeckCardsRoute,
    MenuGlobalDecksDeckUuidDeckStatisticsRoute:
      MenuGlobalDecksDeckUuidDeckStatisticsRoute,
    MenuGlobalDecksDeckUuidDeckIndexRoute:
      MenuGlobalDecksDeckUuidDeckIndexRoute,
  }

const MenuGlobalDecksDeckUuidDeckRouteWithChildren =
  MenuGlobalDecksDeckUuidDeckRoute._addFileChildren(
    MenuGlobalDecksDeckUuidDeckRouteChildren,
  )

interface MenuSharedCollectionsTokenSharedRouteChildren {
  MenuSharedCollectionsTokenSharedCardsRoute: typeof MenuSharedCollectionsTokenSharedCardsRoute
  MenuSharedCollectionsTokenSharedStatisticsRoute: typeof MenuSharedCollectionsTokenSharedStatisticsRoute
  MenuSharedCollectionsTokenSharedIndexRoute: typeof MenuSharedCollectionsTokenSharedIndexRoute
}

const MenuSharedCollectionsTokenSharedRouteChildren: MenuSharedCollectionsTokenSharedRouteChildren =
  {
    MenuSharedCollectionsTokenSharedCardsRoute:
      MenuSharedCollectionsTokenSharedCardsRoute,
    MenuSharedCollectionsTokenSharedStatisticsRoute:
      MenuSharedCollectionsTokenSharedStatisticsRoute,
    MenuSharedCollectionsTokenSharedIndexRoute:
      MenuSharedCollectionsTokenSharedIndexRoute,
  }

const MenuSharedCollectionsTokenSharedRouteWithChildren =
  MenuSharedCollectionsTokenSharedRoute._addFileChildren(
    MenuSharedCollectionsTokenSharedRouteChildren,
  )

interface MenuSharedDecksTokenSharedRouteChildren {
  MenuSharedDecksTokenSharedCardsRoute: typeof MenuSharedDecksTokenSharedCardsRoute
  MenuSharedDecksTokenSharedStatisticsRoute: typeof MenuSharedDecksTokenSharedStatisticsRoute
  MenuSharedDecksTokenSharedIndexRoute: typeof MenuSharedDecksTokenSharedIndexRoute
}

const MenuSharedDecksTokenSharedRouteChildren: MenuSharedDecksTokenSharedRouteChildren =
  {
    MenuSharedDecksTokenSharedCardsRoute: MenuSharedDecksTokenSharedCardsRoute,
    MenuSharedDecksTokenSharedStatisticsRoute:
      MenuSharedDecksTokenSharedStatisticsRoute,
    MenuSharedDecksTokenSharedIndexRoute: MenuSharedDecksTokenSharedIndexRoute,
  }

const MenuSharedDecksTokenSharedRouteWithChildren =
  MenuSharedDecksTokenSharedRoute._addFileChildren(
    MenuSharedDecksTokenSharedRouteChildren,
  )

interface MenuSharedTournamentsTokenSharedRouteChildren {
  MenuSharedTournamentsTokenSharedParticipantsRoute: typeof MenuSharedTournamentsTokenSharedParticipantsRoute
  MenuSharedTournamentsTokenSharedRoundsRoute: typeof MenuSharedTournamentsTokenSharedRoundsRoute
  MenuSharedTournamentsTokenSharedStandingsRoute: typeof MenuSharedTournamentsTokenSharedStandingsRoute
  MenuSharedTournamentsTokenSharedTopCutRoute: typeof MenuSharedTournamentsTokenSharedTopCutRoute
  MenuSharedTournamentsTokenSharedIndexRoute: typeof MenuSharedTournamentsTokenSharedIndexRoute
}

const MenuSharedTournamentsTokenSharedRouteChildren: MenuSharedTournamentsTokenSharedRouteChildren =
  {
    MenuSharedTournamentsTokenSharedParticipantsRoute:
      MenuSharedTournamentsTokenSharedParticipantsRoute,
    MenuSharedTournamentsTokenSharedRoundsRoute:
      MenuSharedTournamentsTokenSharedRoundsRoute,
    MenuSharedTournamentsTokenSharedStandingsRoute:
      MenuSharedTournamentsTokenSharedStandingsRoute,
    MenuSharedTournamentsTokenSharedTopCutRoute:
      MenuSharedTournamentsTokenSharedTopCutRoute,
    MenuSharedTournamentsTokenSharedIndexRoute:
      MenuSharedTournamentsTokenSharedIndexRoute,
  }

const MenuSharedTournamentsTokenSharedRouteWithChildren =
  MenuSharedTournamentsTokenSharedRoute._addFileChildren(
    MenuSharedTournamentsTokenSharedRouteChildren,
  )

interface MenuRouteChildren {
  MenuAdminRoute: typeof MenuAdminRouteWithChildren
  MenuAuthRoute: typeof MenuAuthRouteWithChildren
  MenuGameUtilsRoute: typeof MenuGameUtilsRouteWithChildren
  MenuHomeRoute: typeof MenuHomeRoute
  MenuLegalRoute: typeof MenuLegalRoute
  MenuPrivacyRoute: typeof MenuPrivacyRoute
  MenuWhatsNewRoute: typeof MenuWhatsNewRoute
  MenuIndexRoute: typeof MenuIndexRoute
  MenuProfileProfileRoute: typeof MenuProfileProfileRouteWithChildren
  MenuScanBenchRoute: typeof MenuScanBenchRoute
  MenuTournamentsOverviewRoute: typeof MenuTournamentsOverviewRouteWithChildren
  MenuTournamentsCreateRoute: typeof MenuTournamentsCreateRoute
  MenuWatchListsWatchListUuidRoute: typeof MenuWatchListsWatchListUuidRoute
  MenuCollectionsIndexRoute: typeof MenuCollectionsIndexRoute
  MenuDecksIndexRoute: typeof MenuDecksIndexRoute
  MenuScanIndexRoute: typeof MenuScanIndexRoute
  MenuWatchListsIndexRoute: typeof MenuWatchListsIndexRoute
  MenuCollaboratingDeckUuidDeckRoute: typeof MenuCollaboratingDeckUuidDeckRouteWithChildren
  MenuCollectionsCollectionUuidCollectionRoute: typeof MenuCollectionsCollectionUuidCollectionRouteWithChildren
  MenuDecksDeckUuidDeckRoute: typeof MenuDecksDeckUuidDeckRouteWithChildren
  MenuGlobalProfilesUsernameRoute: typeof MenuGlobalProfilesUsernameRoute
  MenuScanStagedSessionUuidRoute: typeof MenuScanStagedSessionUuidRoute
  MenuTournamentsTournamentUuidTournamentRoute: typeof MenuTournamentsTournamentUuidTournamentRouteWithChildren
  MenuTournamentsTournamentUuidEditRoute: typeof MenuTournamentsTournamentUuidEditRoute
  MenuGlobalDecksIndexRoute: typeof MenuGlobalDecksIndexRoute
  MenuGlobalCollectionsCollectionUuidCollectionRoute: typeof MenuGlobalCollectionsCollectionUuidCollectionRouteWithChildren
  MenuGlobalDecksDeckUuidDeckRoute: typeof MenuGlobalDecksDeckUuidDeckRouteWithChildren
  MenuSharedCollectionsTokenSharedRoute: typeof MenuSharedCollectionsTokenSharedRouteWithChildren
  MenuSharedDecksTokenSharedRoute: typeof MenuSharedDecksTokenSharedRouteWithChildren
  MenuSharedTournamentsTokenSharedRoute: typeof MenuSharedTournamentsTokenSharedRouteWithChildren
  MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute: typeof MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute
}

const MenuRouteChildren: MenuRouteChildren = {
  MenuAdminRoute: MenuAdminRouteWithChildren,
  MenuAuthRoute: MenuAuthRouteWithChildren,
  MenuGameUtilsRoute: MenuGameUtilsRouteWithChildren,
  MenuHomeRoute: MenuHomeRoute,
  MenuLegalRoute: MenuLegalRoute,
  MenuPrivacyRoute: MenuPrivacyRoute,
  MenuWhatsNewRoute: MenuWhatsNewRoute,
  MenuIndexRoute: MenuIndexRoute,
  MenuProfileProfileRoute: MenuProfileProfileRouteWithChildren,
  MenuScanBenchRoute: MenuScanBenchRoute,
  MenuTournamentsOverviewRoute: MenuTournamentsOverviewRouteWithChildren,
  MenuTournamentsCreateRoute: MenuTournamentsCreateRoute,
  MenuWatchListsWatchListUuidRoute: MenuWatchListsWatchListUuidRoute,
  MenuCollectionsIndexRoute: MenuCollectionsIndexRoute,
  MenuDecksIndexRoute: MenuDecksIndexRoute,
  MenuScanIndexRoute: MenuScanIndexRoute,
  MenuWatchListsIndexRoute: MenuWatchListsIndexRoute,
  MenuCollaboratingDeckUuidDeckRoute:
    MenuCollaboratingDeckUuidDeckRouteWithChildren,
  MenuCollectionsCollectionUuidCollectionRoute:
    MenuCollectionsCollectionUuidCollectionRouteWithChildren,
  MenuDecksDeckUuidDeckRoute: MenuDecksDeckUuidDeckRouteWithChildren,
  MenuGlobalProfilesUsernameRoute: MenuGlobalProfilesUsernameRoute,
  MenuScanStagedSessionUuidRoute: MenuScanStagedSessionUuidRoute,
  MenuTournamentsTournamentUuidTournamentRoute:
    MenuTournamentsTournamentUuidTournamentRouteWithChildren,
  MenuTournamentsTournamentUuidEditRoute:
    MenuTournamentsTournamentUuidEditRoute,
  MenuGlobalDecksIndexRoute: MenuGlobalDecksIndexRoute,
  MenuGlobalCollectionsCollectionUuidCollectionRoute:
    MenuGlobalCollectionsCollectionUuidCollectionRouteWithChildren,
  MenuGlobalDecksDeckUuidDeckRoute:
    MenuGlobalDecksDeckUuidDeckRouteWithChildren,
  MenuSharedCollectionsTokenSharedRoute:
    MenuSharedCollectionsTokenSharedRouteWithChildren,
  MenuSharedDecksTokenSharedRoute: MenuSharedDecksTokenSharedRouteWithChildren,
  MenuSharedTournamentsTokenSharedRoute:
    MenuSharedTournamentsTokenSharedRouteWithChildren,
  MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute:
    MenuTournamentsTournamentUuidMatchesMatchUuidLifeRoute,
}

const MenuRouteWithChildren = MenuRoute._addFileChildren(MenuRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  CollectRoute: CollectRouteWithChildren,
  MenuRoute: MenuRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
